"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6914],{

/***/ 52769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ useGoogleLocationServices; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useGoogleLocationServices = function() {
    var geocoder = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var autocompleteService = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isDone = ref[0], setIsDone = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function initializeGoogleServices() {
        if (!window.google) return;
        setIsDone(true);
        geocoder.current = new google.maps.Geocoder();
        autocompleteService.current = new google.maps.places.AutocompleteService();
    }, [
        window.google,
        isDone
    ]);
    return {
        geocoder: geocoder.current,
        autocompleteService: autocompleteService.current
    };
};


/***/ }),

/***/ 52428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var _fluidtruck_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46052);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_ForgotPassword__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65904);
/* harmony import */ var _components_LoginSignup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22588);





var SummaryLoginContainer = (0,_fluidtruck_core__WEBPACK_IMPORTED_MODULE_3__/* .chakra */ .m$)("div", {
    baseStyle: {
        marginTop: -5,
        height: {
            base: "100%",
            lg: "88%"
        },
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignSelf: "center"
    },
    label: "SummaryLoginContainer"
});
var ForgotPasswordContainer = (0,_fluidtruck_core__WEBPACK_IMPORTED_MODULE_3__/* .chakra */ .m$)("div", {
    baseStyle: {
        height: {
            base: "100%",
            lg: "calc(100% - 40px)"
        }
    },
    label: "ForgotPasswordContainer"
});
var SummaryLogin = function(param) {
    var onFinish = param.onFinish;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), forgotPassword = ref[0], setForgotPassword = ref[1];
    if (forgotPassword) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ForgotPasswordContainer, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_components_ForgotPassword__WEBPACK_IMPORTED_MODULE_1__/* .ForgotPassword */ .o, {
                setForgotPassword: setForgotPassword
            })
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(SummaryLoginContainer, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_components_LoginSignup__WEBPACK_IMPORTED_MODULE_2__/* .Login */ .m3, {
            blockOnSubmit: true,
            setForgotPassword: setForgotPassword,
            onFinish: onFinish
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SummaryLogin);


/***/ }),

/***/ 56914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SearchPage_SearchPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(80008);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/LocationAutocompleteV2/hooks/useGoogleLocationServices.ts
var useGoogleLocationServices = __webpack_require__(52769);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js
var chakra_ui_button_esm = __webpack_require__(15193);
// EXTERNAL MODULE: ./node_modules/@fluidtruck/icons/dist/esm/Filter.js
var Filter = __webpack_require__(56083);
// EXTERNAL MODULE: ./node_modules/@fluidtruck/icons/dist/esm/Search.js
var Search = __webpack_require__(77294);
// EXTERNAL MODULE: ./node_modules/@fluidtruck/icons/dist/esm/Map.js
var Map = __webpack_require__(99125);
// EXTERNAL MODULE: ./node_modules/@fluidtruck/icons/dist/esm/List.js
var List = __webpack_require__(71618);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(52795);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 55 modules
var esm = __webpack_require__(71750);
// EXTERNAL MODULE: ./amplitude/index.ts
var amplitude = __webpack_require__(42001);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js
var chakra_ui_system_esm = __webpack_require__(46052);
// EXTERNAL MODULE: ./node_modules/@fluidtruck/modal/dist/esm/modal-close-button.js + 1 modules
var modal_close_button = __webpack_require__(6011);
// EXTERNAL MODULE: ./base-components/buttons/Buttons.tsx + 1 modules
var Buttons = __webpack_require__(95514);
// EXTERNAL MODULE: ./hooks/index.js + 25 modules
var hooks = __webpack_require__(73677);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chakra-ui-modal.esm.js + 55 modules
var chakra_ui_modal_esm = __webpack_require__(68131);
;// CONCATENATED MODULE: ./base-components/Drawer/index.tsx








var DrawerCloseButton = (0,chakra_ui_system_esm/* forwardRef */.Gp)(function(props, ref) {
    var router = (0,next_router.useRouter)();
    var user = (0,hooks/* useUser */.aF)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(modal_close_button/* ModalCloseButton */.o, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        ref: ref,
        onClick: function(e) {
            var _$ref, _$ref1, _$ref2;
            (0,Buttons/* onClickAmplitude */.lz)({
                buttonText: "Drawer Close Button",
                pageName: window.document.title,
                entityId: Object.entries(router.query),
                userId: user === null || user === void 0 ? void 0 : (_$ref = user.user) === null || _$ref === void 0 ? void 0 : _$ref.id,
                orgId: user === null || user === void 0 ? void 0 : (_$ref1 = user.user) === null || _$ref1 === void 0 ? void 0 : _$ref1["default-organization-id"]
            });
            (_$ref2 = props.onClick) === null || _$ref2 === void 0 ? void 0 : _$ref2.call(props, e);
        }
    }));
});

// EXTERNAL MODULE: ./base-components/modals/index.ts + 1 modules
var modals = __webpack_require__(88492);
;// CONCATENATED MODULE: ./base-components/MaintenanceBanner/MaintenanceBanner.tsx






var MaintenanceBanner = function(param) {
    var details = param.details, startAt = param.startAt, endAt = param.endAt, status = param.status;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "maintenance"
    ]).t;
    var ref1 = (0,hooks/* useResize */.aB)(), isMobile = ref1.isMobile, isIpad = ref1.isIpad, isDesktop = ref1.isDesktop;
    var modalHeaderSize = isMobile ? 18 : 22;
    var bannerTextSize = isMobile ? 16 : 18;
    var modalHeight = (isIpad || isDesktop) && 500;
    var handleClick = function() {
        return setOpen(function(prevState) {
            return !prevState;
        });
    };
    var isActive = status === "active";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Flex */.kC, {
                style: {
                    width: "100%",
                    height: isMobile ? 76 : 50,
                    cursor: "pointer"
                },
                backgroundColor: "cheese",
                alignItems: "center",
                justifyContent: "center",
                onClick: handleClick,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                    mb: 0,
                    color: "white",
                    fontSize: bannerTextSize,
                    fontWeight: 700,
                    pl: 3,
                    pr: 3,
                    textAlign: "center",
                    children: isActive ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(esm/* Trans */.cC, {
                        t: t,
                        i18nKey: "common:maintenance.currentOutage",
                        children: [
                            "There is a current maintenance outage until ",
                            {
                                endAt: endAt
                            }
                        ]
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(esm/* Trans */.cC, {
                        t: t,
                        i18nKey: "common:maintenance.futureOutage",
                        children: [
                            "There will be a maintenance outage from ",
                            {
                                startAt: startAt
                            },
                            " to",
                            {
                                endAt: endAt
                            },
                            "."
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(modals/* ModalGroup */.V, {
                onClose: handleClick,
                size: isMobile ? "full" : "md",
                bodyProps: {
                    style: {
                        minHeight: modalHeight
                    }
                },
                headerProps: {
                    style: {
                        fontSize: modalHeaderSize
                    }
                },
                isOpen: open,
                title: t("maintenance:outage.maintenanceWindowDetails"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Text */.xv, {
                    align: "center",
                    pt: 3,
                    children: details
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./base-components/MaintenanceBanner/index.tsx


// EXTERNAL MODULE: ./node_modules/@fluidtruck/icons/dist/esm/EVBadge.js
var EVBadge = __webpack_require__(90211);
// EXTERNAL MODULE: ./node_modules/@fluidtruck/icons/dist/esm/InstantBook.js
var InstantBook = __webpack_require__(39698);
// EXTERNAL MODULE: ./node_modules/swr/dist/core/index.mjs
var core = __webpack_require__(59820);
// EXTERNAL MODULE: ./base-components/index.ts + 14 modules
var base_components = __webpack_require__(9891);
// EXTERNAL MODULE: ./base-components/Link/index.ts + 1 modules
var Link = __webpack_require__(22707);
// EXTERNAL MODULE: ./components/SimpleVehicleMap/SimpleVehicleMap.tsx
var SimpleVehicleMap = __webpack_require__(47511);
// EXTERNAL MODULE: ./lib/context/index.ts + 3 modules
var lib_context = __webpack_require__(63618);
// EXTERNAL MODULE: ./utils/conversions.ts
var conversions = __webpack_require__(59194);
// EXTERNAL MODULE: ./utils/helpers.js
var helpers = __webpack_require__(44108);
// EXTERNAL MODULE: ./utils/location.js
var utils_location = __webpack_require__(14361);
// EXTERNAL MODULE: ./utils/maps/map-icons/vehicle-location-marker.tsx
var vehicle_location_marker = __webpack_require__(52071);
// EXTERNAL MODULE: ./utils/maps/svgToBase64.ts
var svgToBase64 = __webpack_require__(71141);
// EXTERNAL MODULE: ./components/VehicleDetail/ReviewsContainer.jsx + 1 modules
var ReviewsContainer = __webpack_require__(70842);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 5 modules
var emotion_styled_browser_esm = __webpack_require__(78555);
// EXTERNAL MODULE: ./node_modules/@fluidtruck/icons/dist/esm/Star.js
var Star = __webpack_require__(76769);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./components/Item/Rating.js






var Spacer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eqmvu580"
})({
    marginRight: 4,
    height: 20
});
var Rating = function(param) {
    var rating = param.rating, reviewCount = param.reviewCount;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Grid/* default */.Z, {
        item: true,
        container: true,
        xs: true,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.Z, {
                item: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Spacer, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Star/* StarIcon */.r, {
                        color: "cheese"
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.Z, {
                item: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Spacer, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* SubHeader */.bU, {
                        size: 16,
                        children: rating
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.Z, {
                item: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Spacer, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* HeaderLink */.KS, {
                        size: 16,
                        children: [
                            "(",
                            reviewCount,
                            ")"
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Item_Rating = (Rating);
Rating.propTypes = {
    rating: (prop_types_default()).number,
    reviewCount: (prop_types_default()).number
};
Rating.defaultProps = {
    rating: 0,
    reviewCount: 0
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider_Divider = __webpack_require__(55517);
// EXTERNAL MODULE: ./theme/index.ts
var theme = __webpack_require__(83488);
;// CONCATENATED MODULE: ./components/Item/styles.ts








var topNavMobile = theme/* heights.topNavMobile */.Db.topNavMobile, searchBar = theme/* heights.searchBar */.Db.searchBar;
var mqMax = (0,helpers/* generateMQ */.Nt)("max");
var SmallText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(base_components/* SubHeader */.bU, {
    target: "e1t5iwxc0"
})(function(props) {
    var ref, ref1;
    return (0,src_define_property/* default */.Z)({
        color: props === null || props === void 0 ? void 0 : (ref = props.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.gray[900],
        display: "flex",
        alignItems: "flex-end"
    }, mqMax[0], {
        fontSize: 14
    });
});
var DividerContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1t5iwxc1"
})({
    display: "flex",
    alignItems: "flex-end",
    marginBottom: 3
});
var MileageContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1t5iwxc2"
})({
    display: "flex",
    paddingTop: 11
});
var StyledDivider = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Divider_Divider/* default */.Z, {
    target: "e1t5iwxc3"
})(function(props) {
    var ref, ref1;
    return {
        backgroundColor: props === null || props === void 0 ? void 0 : (ref = props.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.gray[700],
        margin: "0 8px"
    };
});
var MapContainer = (0,chakra_ui_system_esm/* chakra */.m$)("div", {
    baseStyle: {
        height: "350px",
        width: "inherit"
    },
    label: "MapContainer"
});
var Details = (0,chakra_ui_system_esm/* chakra */.m$)(base_components/* Grid */.rj, {
    baseStyle: {
        alignItems: "center",
        gridGap: 4,
        alignSelf: "end",
        mt: 3
    },
    label: "Details"
});
var ItemDetailContainer = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Flex */.kC, {
    baseStyle: {
        flexDirection: "column",
        pb: {
            base: "".concat(topNavMobile + searchBar, "px"),
            lg: 5
        },
        width: "100%"
    },
    label: "ItemDetailContainer"
});
var LoadingContainer = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Flex */.kC, {
    baseStyle: {
        width: {
            base: "100%",
            md: "450px"
        },
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: 360
    },
    label: "LoadingContainer"
});
var ImageCarouselContainer = (0,chakra_ui_system_esm/* chakra */.m$)(chakra_ui_layout_esm/* Flex */.kC, {
    baseStyle: {
        mt: 8,
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        mb: 7
    },
    label: "ImageCarouselContainer"
});
var FlexContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1t5iwxc4"
})({
    display: "flex",
    paddingTop: 26
});
var InnerFlexContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1t5iwxc5"
})({
    display: "flex",
    paddingRight: 16
});

;// CONCATENATED MODULE: ./components/Item/ItemDetail.tsx

























var ItemDetail = function(param) {
    var id = param.id, updateDetailView = param.updateDetailView, isAvailable = param.isAvailable;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51;
    var user = (0,hooks/* useUser */.aF)().user;
    var isDesktop = (0,hooks/* useResize */.aB)().isDesktop;
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "messages",
        "search"
    ]).t;
    var router = (0,next_router.useRouter)();
    var ref52 = (0,hooks/* useOrganizationContext */.mP)(), _context = ref52.context, organization = _context.org.organization;
    var ref53 = (0,react.useState)(), userLocation = ref53[0], setUserLocation = ref53[1];
    var rootRef = (0,react.useRef)(null);
    var reviewsRef = (0,react.useRef)(null);
    var ref54 = (0,core/* default */.ZP)("api/publicitems/".concat(id), helpers/* get */.U2), itemData = ref54.data;
    var reservationEstimate = (0,lib_context/* useReservationEstimate */.Qf)().reservationEstimate;
    var ref55 = (0,core/* default */.ZP)("api/reviews?id=".concat(id, "&type=reservation"), helpers/* get */.U2), reviewData = ref55.data;
    (0,react.useEffect)(function() {
        function loadLocation() {
            return _loadLocation.apply(this, arguments);
        }
        function _loadLocation() {
            _loadLocation = (0,_async_to_generator/* default */.Z)(function() {
                var res;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,utils_location/* currentLocation */.DX)()
                            ];
                        case 1:
                            res = _state.sent();
                            setUserLocation(res);
                            return [
                                2
                            ];
                    }
                });
            });
            return _loadLocation.apply(this, arguments);
        }
        loadLocation();
    }, []);
    (0,react.useEffect)(function() {
        if (isDesktop) {
            var ref = rootRef === null || rootRef === void 0 ? void 0 : rootRef.current;
            if (!ref) return;
            ref.scrollIntoView();
        }
    }, [
        id,
        isDesktop,
        rootRef
    ]);
    var handleSubmitClick = function(e) {
        amplitude/* ampli.vehicleDetailsReserve */.iN.vehicleDetailsReserve({
            userId: (user === null || user === void 0 ? void 0 : user.id) || undefined
        });
        var innerText = e.target.innerText;
        if (organization && (organization === null || organization === void 0 ? void 0 : organization["borrow-limit"]) <= 1 && innerText === t("common:button.reserve")) {
            router.push("/book");
            return;
        }
        updateDetailView({
            type: "reservation",
            detailViewId: id
        });
    };
    var rawLat = itemData === null || itemData === void 0 ? void 0 : (ref = itemData.data) === null || ref === void 0 ? void 0 : (ref1 = ref.location) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.coordinates) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.lat) === null || ref3 === void 0 ? void 0 : ref3.toFixed(6); // || 39.752256;
    var rawLng = itemData === null || itemData === void 0 ? void 0 : (ref4 = itemData.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.location) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.coordinates) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.lng) === null || ref7 === void 0 ? void 0 : ref7.toFixed(6); // || -104.995233;
    var lat = rawLat ? parseFloat(rawLat) : 39.752256;
    var lng = rawLng ? parseFloat(rawLng) : -104.995233;
    var pin = {
        url: (0,svgToBase64/* svgToBase64 */.b)({
            icon: (0,vehicle_location_marker/* vehicleLocationMarker */.i)(isAvailable)
        })
    };
    var isElectric = itemData === null || itemData === void 0 ? void 0 : (ref8 = itemData.data) === null || ref8 === void 0 ? void 0 : ref8["is-electric-vehicle"];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        ref: rootRef,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemDetailContainer, {
            "data-test-id": "item-detail-container",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ImageCarouselContainer, {
                    children: [
                        (itemData === null || itemData === void 0 ? void 0 : (ref9 = itemData.data) === null || ref9 === void 0 ? void 0 : ref9.pictures) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* ImageCarousel */.Li, {
                            images: ((itemData === null || itemData === void 0 ? void 0 : (ref10 = itemData.data) === null || ref10 === void 0 ? void 0 : ref10.pictures) || []).map(function(i) {
                                return i === null || i === void 0 ? void 0 : i.standard;
                            })
                        }),
                        !(itemData === null || itemData === void 0 ? void 0 : (ref11 = itemData.data) === null || ref11 === void 0 ? void 0 : ref11.pictures) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingContainer, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* SpinnerContainer */.eg, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Title */.Dx, {
                    "data-test-id": "item-detail-title",
                    children: itemData === null || itemData === void 0 ? void 0 : (ref12 = itemData.data) === null || ref12 === void 0 ? void 0 : ref12.title
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FlexContainer, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InnerFlexContainer, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* Header */.h4, {
                                    size: 32,
                                    children: [
                                        "$",
                                        (0,conversions/* centsToDollars */.G_)((reservationEstimate === null || reservationEstimate === void 0 ? void 0 : (ref13 = reservationEstimate.item) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.rates) === null || ref14 === void 0 ? void 0 : ref14.hourly) || 0)
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DividerContainer, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDivider, {
                                        orientation: "vertical",
                                        style: {
                                            margin: "0 4px",
                                            height: 17
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SmallText, {
                                    size: 16,
                                    children: "hour"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InnerFlexContainer, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* Header */.h4, {
                                    size: 32,
                                    children: [
                                        "$",
                                        (0,conversions/* centsToDollars */.G_)((reservationEstimate === null || reservationEstimate === void 0 ? void 0 : (ref15 = reservationEstimate.item) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.rates) === null || ref16 === void 0 ? void 0 : ref16.daily) || 0)
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DividerContainer, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDivider, {
                                        orientation: "vertical",
                                        style: {
                                            margin: "0 4px",
                                            height: 17
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SmallText, {
                                    size: 16,
                                    children: "day"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InnerFlexContainer, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* Header */.h4, {
                                    size: 32,
                                    children: [
                                        "$",
                                        (0,conversions/* centsToDollars */.G_)((reservationEstimate === null || reservationEstimate === void 0 ? void 0 : (ref17 = reservationEstimate.item) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.rates) === null || ref18 === void 0 ? void 0 : ref18.weekly) || 0)
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DividerContainer, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDivider, {
                                        orientation: "vertical",
                                        style: {
                                            margin: "0 4px",
                                            height: 17
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SmallText, {
                                    size: 16,
                                    children: "week"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MileageContainer, {
                    children: (reservationEstimate === null || reservationEstimate === void 0 ? void 0 : (ref19 = reservationEstimate.item) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.details) === null || ref20 === void 0 ? void 0 : ref20.unlimited_miles) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SmallText, {
                        size: 16,
                        children: t("common:unlimitedMileage")
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SmallText, {
                                size: 16,
                                children: t("search:includedMilage", {
                                    mileage: (reservationEstimate === null || reservationEstimate === void 0 ? void 0 : (ref21 = reservationEstimate.item) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.details) === null || ref22 === void 0 ? void 0 : ref22.mileage_limit_daily) || 0
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DividerContainer, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDivider, {
                                    orientation: "vertical",
                                    style: {
                                        height: 17
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SmallText, {
                                size: 16,
                                children: [
                                    (0,conversions/* formatMoney */.lb)((0,conversions/* centsToDollars */.G_)((reservationEstimate === null || reservationEstimate === void 0 ? void 0 : (ref23 = reservationEstimate.item) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.details) === null || ref24 === void 0 ? void 0 : ref24.cost_per_mile) || 0)),
                                    " ",
                                    t("search:perAdditionalMile")
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Details, {
                    templateColumns: isElectric ? "auto 1fr" : "auto",
                    children: [
                        isElectric && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
                            gap: 2,
                            alignItems: "center",
                            children: [
                                "Electric Vehicle",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EVBadge/* EVBadgeIcon */.T, {
                                    h: 5,
                                    w: 5
                                })
                            ]
                        }),
                        (itemData === null || itemData === void 0 ? void 0 : (ref25 = itemData.data) === null || ref25 === void 0 ? void 0 : ref25.instabook) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
                            gap: 2,
                            alignItems: "center",
                            children: [
                                t("common:instantBook"),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InstantBook/* InstantBookIcon */.n, {
                                    color: "cheese",
                                    h: 5,
                                    w: 5
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* SubmitButton */.Mm, {
                    mt: {
                        base: 3,
                        md: 0
                    },
                    width: {
                        base: "100%",
                        lg: "fit-content"
                    },
                    isDisabled: !isAvailable,
                    onClick: handleSubmitClick,
                    children: isAvailable ? t("common:button.reserve") : t("common:button.unavailable")
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Divider */.iz, {
                    my: 8,
                    color: "gray.400"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
                    gap: 2,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Avatar */.qE, {
                            src: itemData === null || itemData === void 0 ? void 0 : (ref26 = itemData.data) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.lender) === null || ref27 === void 0 ? void 0 : ref27["avatar-url"]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* BoldText */.xW, {
                            fontSize: "lg",
                            children: itemData === null || itemData === void 0 ? void 0 : (ref28 = itemData.data) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.lender) === null || ref29 === void 0 ? void 0 : ref29.first
                        }),
                        (reviewData === null || reviewData === void 0 ? void 0 : (ref30 = reviewData.data) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.entries) === null || ref31 === void 0 ? void 0 : ref31.length) > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            style: {
                                cursor: "pointer"
                            },
                            role: "presentation",
                            onClick: function() {
                                return (0,helpers/* scrollToRef */.BC)(reviewsRef);
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Item_Rating, {
                                rating: itemData === null || itemData === void 0 ? void 0 : (ref32 = itemData.data) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.lender) === null || ref33 === void 0 ? void 0 : ref33["average-rating"],
                                reviewCount: reviewData === null || reviewData === void 0 ? void 0 : (ref34 = reviewData.data) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.entries) === null || ref35 === void 0 ? void 0 : ref35.length
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* Grid */.rj, {
                    gap: 3,
                    mt: 6,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Title */.Dx, {
                            fontSize: "3xl",
                            children: "Overview"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Text */.xv, {
                            children: itemData === null || itemData === void 0 ? void 0 : (ref36 = itemData.data) === null || ref36 === void 0 ? void 0 : ref36.description
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Title */.Dx, {
                            mt: "3",
                            fontSize: "3xl",
                            children: "Pick Up / Drop Off Location"
                        }),
                        lat && lng && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MapContainer, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimpleVehicleMap/* SimpleVehicleLocationMap */.z, {
                                center: {
                                    lat: lat,
                                    lng: lng
                                },
                                icon: (0,src_object_spread/* default */.Z)({}, pin)
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* GridItem */.P4, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* Text */.xv, {
                                    children: [
                                        "This vehicle is",
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                                            children: "".concat((0,conversions/* distance */.TE)(itemData === null || itemData === void 0 ? void 0 : (ref37 = itemData.data) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.location) === null || ref38 === void 0 ? void 0 : ref38.coordinates, userLocation).toFixed(2), " miles")
                                        }),
                                        " ",
                                        "away"
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                    fontSize: "lg",
                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                    // @ts-ignore
                                    href: (itemData === null || itemData === void 0 ? void 0 : (ref39 = itemData.data) === null || ref39 === void 0 ? void 0 : (ref40 = ref39.location) === null || ref40 === void 0 ? void 0 : ref40.address) && "https://www.google.com/maps/search/?api=1&query=".concat(encodeURIComponent(itemData === null || itemData === void 0 ? void 0 : (ref41 = itemData.data) === null || ref41 === void 0 ? void 0 : (ref42 = ref41.location) === null || ref42 === void 0 ? void 0 : ref42.address)),
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: itemData === null || itemData === void 0 ? void 0 : (ref43 = itemData.data) === null || ref43 === void 0 ? void 0 : (ref44 = ref43.location) === null || ref44 === void 0 ? void 0 : ref44.address
                                })
                            ]
                        }),
                        (reviewData === null || reviewData === void 0 ? void 0 : (ref45 = reviewData.data) === null || ref45 === void 0 ? void 0 : (ref46 = ref45.entries) === null || ref46 === void 0 ? void 0 : ref46.length) > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* Grid */.rj, {
                            "data-test-id": "reviews",
                            mt: 6,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Header */.h4, {
                                            size: 24,
                                            style: {
                                                marginRight: 10
                                            },
                                            children: "Reviews"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Item_Rating, {
                                            rating: itemData === null || itemData === void 0 ? void 0 : (ref47 = itemData.data) === null || ref47 === void 0 ? void 0 : (ref48 = ref47.lender) === null || ref48 === void 0 ? void 0 : ref48["average-rating"],
                                            reviewCount: reviewData === null || reviewData === void 0 ? void 0 : (ref49 = reviewData.data) === null || ref49 === void 0 ? void 0 : (ref50 = ref49.entries) === null || ref50 === void 0 ? void 0 : ref50.length
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    ref: reviewsRef,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReviewsContainer/* default */.Z, {
                                        noHeader: true,
                                        reviewInfo: reviewData === null || reviewData === void 0 ? void 0 : (ref51 = reviewData.data) === null || ref51 === void 0 ? void 0 : ref51.entries
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Item_ItemDetail = (ItemDetail);

// EXTERNAL MODULE: ./node_modules/@fluidtruck/icons/dist/esm/CargoVan.js
var CargoVan = __webpack_require__(43937);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Popover/Popover.js
var Popover = __webpack_require__(52387);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Toolbar/Toolbar.js
var Toolbar = __webpack_require__(28358);
// EXTERNAL MODULE: ./utils/index.js + 1 modules
var utils = __webpack_require__(57561);
;// CONCATENATED MODULE: ./components/ItemCart/itemCartCardStyles.js


var DateTimeContainer = (0,utils/* chakra */.m$)("div", {
    baseStyle: {
        alignItems: "center",
        display: "grid",
        gridTemplateColumns: "1fr 48px",
        mt: 6
    },
    label: "DateTimeContainer"
});
var Features = (0,utils/* chakra */.m$)(chakra_ui_layout_esm/* Flex */.kC, {
    baseStyle: {
        alignItems: "center",
        justifyContent: "flex-end",
        "& img:last-of-type": {
            marginLeft: 8
        }
    },
    label: "Features"
});
var Row = (0,utils/* chakra */.m$)(chakra_ui_layout_esm/* Flex */.kC, {
    baseStyle: {
        alignItems: "center"
    },
    label: "Row"
});
var DateContainer = (0,utils/* chakra */.m$)(chakra_ui_layout_esm/* Text */.xv, {
    baseStyle: {
        lineHeight: "8",
        fontWeight: "bold",
        width: "auto"
    },
    label: "DateContainer"
});
var Image = (0,utils/* chakra */.m$)("img", {
    baseStyle: {
        width: "100%",
        overflow: "hidden",
        display: "block",
        maxWidth: 20,
        borderRadius: "base",
        marginRight: 3
    }
});
var HeaderDivider = (0,utils/* chakra */.m$)(chakra_ui_layout_esm/* Divider */.iz, {
    baseStyle: {
        borderColor: "keylineGray",
        margin: "12px auto"
    }
});

;// CONCATENATED MODULE: ./components/ItemCart/ItemCartCard.jsx













var ItemCartCard = function(param) {
    var pickUp = param.pickUp, dropOff = param.dropOff, item = param.item, items = param.items;
    var ref, ref1;
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "search"
    ]).t;
    var userLocation = (0,react.useContext)(lib_context/* ItemsContext */.ct).userLocation;
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var removeItemFromCart = (0,hooks/* useCart */.jD)().removeItemFromCart;
    var handleRemoveItemFromCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        return [
                            4,
                            removeItemFromCart(item === null || item === void 0 ? void 0 : item.id)
                        ];
                    case 1:
                        _state.sent();
                        if (item) setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRemoveItemFromCart() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DateTimeContainer, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row, {
                        justify: "flex-start",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DateContainer, {
                                children: moment_default()(pickUp).format("MM/DD/YY")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Text */.xv, {
                                margin: "auto 3px",
                                children: t("at")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DateContainer, {
                                children: moment_default()(pickUp).format("h:mm a")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Divider */.iz, {
                                margin: "auto 8px",
                                h: 4,
                                borderColor: "darkGray",
                                orientation: "vertical"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DateContainer, {
                                children: moment_default()(dropOff).format("MM/DD/YY")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Text */.xv, {
                                margin: "auto 3px",
                                children: t("at")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DateContainer, {
                                children: moment_default()(dropOff).format("h:mm a")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Features, {
                        children: [
                            item["is-electric-vehicle"] && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EVBadge/* EVBadgeIcon */.T, {
                                h: 5,
                                w: 5
                            }),
                            item.instabook && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InstantBook/* InstantBookIcon */.n, {
                                color: "cheese",
                                h: 5,
                                w: 5
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderDivider, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row, {
                justify: "flex-start",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, {
                        src: (item === null || item === void 0 ? void 0 : (ref = item.pictures) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.url) || "/img/cargo-van-square.png",
                        alt: t("rent")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* FlexCol */.Ht, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* SubHeading */.GL, {
                                children: item === null || item === void 0 ? void 0 : item.title
                            }),
                            !(item === null || item === void 0 ? void 0 : item.title.includes("#")) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* SubHeading */.GL, {
                                fontSize: "lg",
                                mt: 3,
                                children: item === null || item === void 0 ? void 0 : item["fleet-number"]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row, {
                justify: "space-between",
                mt: 3,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* SubHeading */.GL, {
                        children: [
                            (0,conversions/* distance */.TE)(userLocation, item === null || item === void 0 ? void 0 : item.location).toFixed(2),
                            " mi"
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* FlexRow */.gq, {
                        justify: "flex-end",
                        alignItems: "flex-end",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* MidText */.Jc, {
                                color: "darkGray",
                                mr: 1.5,
                                children: t("search:estTotal")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* SubHeading */.GL, {
                                children: (0,conversions/* formatMoney */.lb)((0,conversions/* centsToDollars */.G_)(item === null || item === void 0 ? void 0 : item["estimated-cost"]))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row, {
                position: "relative",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Button */.zx, {
                    isFullWidth: true,
                    isLoading: loading,
                    mt: 3,
                    onClick: handleRemoveItemFromCart,
                    variant: "outline",
                    children: items.length > 1 ? t("button.remove") : t("button.cancel")
                })
            }),
            items.length > 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Divider */.iz, {
                borderColor: "keylineGray",
                width: "100%",
                mt: 6
            })
        ]
    });
};
/* harmony default export */ var ItemCart_ItemCartCard = (ItemCartCard);
ItemCartCard.propTypes = {
    item: prop_types_default().shape({
        id: (prop_types_default()).number,
        title: (prop_types_default()).string,
        location: prop_types_default().shape({
            lat: (prop_types_default()).number,
            lng: (prop_types_default()).number
        }),
        "estimated-cost": (prop_types_default()).number,
        "fleet-number": (prop_types_default()).string,
        "is-electric-vehicle": (prop_types_default()).bool,
        instabook: (prop_types_default()).bool,
        pictures: prop_types_default().arrayOf(prop_types_default().shape({
            url: (prop_types_default()).string
        }))
    }),
    pickUp: (prop_types_default()).string,
    dropOff: (prop_types_default()).string,
    items: (prop_types_default()).array.isRequired
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/AppBar/AppBar.js
var AppBar = __webpack_require__(45258);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Badge/Badge.js
var Badge = __webpack_require__(59009);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/Paper.js
var Paper = __webpack_require__(79895);
;// CONCATENATED MODULE: ./components/ItemCart/itemCartStyles.js









var mq = (0,helpers/* generateMQ */.Nt)("max");
var CartBar = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppBar/* default */.Z, (0,src_object_spread/* default */.Z)({
        color: "default",
        position: "fixed"
    }, props));
}, {
    target: "e1xhk5p70"
})(function(props) {
    var ref, ref1;
    return {
        top: "auto",
        bottom: 0,
        backgroundColor: props === null || props === void 0 ? void 0 : (ref = props.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.white,
        height: 88,
        alignItems: "flex-end"
    };
});
var CartMenuBar = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppBar/* default */.Z, (0,src_object_spread/* default */.Z)({
        color: "default",
        position: "absolute"
    }, props));
}, {
    target: "e1xhk5p71"
})(function(props) {
    var ref, ref1, ref2, ref3;
    return {
        top: 0,
        bottom: "auto",
        backgroundColor: props === null || props === void 0 ? void 0 : (ref = props.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.white,
        height: 50,
        alignItems: "flex-end",
        boxShadow: "none",
        borderWidth: "1px",
        borderColor: props === null || props === void 0 ? void 0 : (ref2 = props.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.gray[400],
        borderRadius: "10px 10px 0 0"
    };
});
var VerticalDivider = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled(function(props) {
    return /*#__PURE__*/ _jsx(Divider, _object_spread({
        orientation: "vertical"
    }, props));
}, {
    target: "e1xhk5p72"
})(function(props) {
    var ref, ref1;
    return _define_property({
        backgroundColor: props === null || props === void 0 ? void 0 : (ref = props.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.gray[400],
        marginRight: 58
    }, mq[0], {
        marginRight: 30
    });
})));
var CartToolBar = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(function(_param) /*#__PURE__*/ {
    var _isMobile = _param.isMobile, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isMobile"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toolbar/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        disableGutters: true
    }));
}, {
    target: "e1xhk5p73"
})(function(props) {
    var ref, ref1;
    return (0,src_define_property/* default */.Z)({
        height: 88,
        borderLeft: props.isMobile ? "none" : "1px solid ".concat(props === null || props === void 0 ? void 0 : (ref = props.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.gray[400])
    }, mq[0], {
        width: "inherit"
    });
});
var CartBadge = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, (0,src_object_spread/* default */.Z)({
        color: "primary",
        anchorOrigin: {
            vertical: "top",
            horizontal: "left"
        }
    }, props));
}, {
    target: "e1xhk5p74"
})(function(props) {
    var ref, ref1;
    return {
        ".MuiBadge-badge": {
            color: props === null || props === void 0 ? void 0 : (ref = props.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.white
        }
    };
});
var EstimateContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1xhk5p75"
})((0,src_define_property/* default */.Z)({
    display: "flex",
    flexDirection: "column",
    marginLeft: 75,
    marginRight: 16
}, mq[0], {
    marginLeft: 0
}));
var EstimateText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Body */.uT, (0,src_object_spread/* default */.Z)({
        size: 14,
        color: "primary"
    }, props));
}, {
    target: "e1xhk5p76"
})({
    textAlign: "right"
});
var EstimateAmount = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Header */.h4, (0,src_object_spread/* default */.Z)({
        size: 24
    }, props));
}, {
    target: "e1xhk5p77"
})({
    textAlign: "right"
});
var CartPopover = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Paper/* default */.Z, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        elevation: 3
    }));
}, {
    target: "e1xhk5p78"
})({
    borderRadius: "10px 10px 0px 0px",
    background: "#fff",
    width: 408,
    padding: "16px 20px",
    overflow: "auto"
});
var _obj;
var ItemListContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1xhk5p79"
})((_obj = {
    marginTop: 16,
    padding: "16px 0px",
    overflow: "auto",
    maxHeight: 300
}, (0,src_define_property/* default */.Z)(_obj, mq[0], {
    maxHeight: "unset",
    height: "calc(100vh - 225px)",
    width: "calc(100% - 32px)"
}), (0,src_define_property/* default */.Z)(_obj, "::-webkit-scrollbar", {
    display: "none"
}), (0,src_define_property/* default */.Z)(_obj, "msOverflowStyle", "none"), (0,src_define_property/* default */.Z)(_obj, "scrollbarWidth", "none"), _obj));
var ButtonContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1xhk5p710"
})((0,src_define_property/* default */.Z)({
    minWidth: "120px"
}, mq[0], {
    minWidth: "80px"
}));

;// CONCATENATED MODULE: ./components/ItemCart/index.jsx














var ItemCart = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var ref11 = (0,react.useState)(null), anchorEl = ref11[0], setAnchorEl = ref11[1];
    var t = (0,esm/* useTranslation */.$G)("search").t;
    var isMobile = (0,hooks/* useResize */.aB)().isMobile;
    var router = (0,next_router.useRouter)();
    var ref12 = (0,hooks/* useCart */.jD)(), cart = ref12.cart, updateCartOrg = ref12.updateCartOrg;
    var context = (0,hooks/* useOrganizationContext */.mP)().context;
    var user = (0,hooks/* useUser */.aF)().user;
    var reservationEstimate = (0,lib_context/* useReservationEstimate */.Qf)().reservationEstimate;
    var itemIds = cart === null || cart === void 0 ? void 0 : (ref = cart.items) === null || ref === void 0 ? void 0 : ref.map(function(i) {
        return i.id;
    });
    var showCart = function(e) {
        setAnchorEl(e.currentTarget);
    };
    var hideCart = function() {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    var handleClick = function() {
        var ref, ref1;
        router.push("/book_cart");
        amplitude/* ampli.viewBookingReviewPage */.iN.viewBookingReviewPage({
            userId: user === null || user === void 0 ? void 0 : user.id,
            orgId: context === null || context === void 0 ? void 0 : (ref = context.org) === null || ref === void 0 ? void 0 : (ref1 = ref.organization) === null || ref1 === void 0 ? void 0 : ref1.id,
            hasBookingCart: true,
            reservationEndTime: reservationEstimate === null || reservationEstimate === void 0 ? void 0 : reservationEstimate["drop-off"],
            reservationStartTime: reservationEstimate === null || reservationEstimate === void 0 ? void 0 : reservationEstimate["pick-up"],
            itemIds: [
                itemIds
            ],
            promoCode: reservationEstimate === null || reservationEstimate === void 0 ? void 0 : reservationEstimate["promo-code"],
            deviceType: isMobile ? "web-mobile" : "web-desktop"
        });
    };
    (0,react.useEffect)(function() {
        // Adding updateCartOrg to deps causes dozens of re-renders.
        if (user) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
            updateCartOrg({
                orgId: (ref = context.org) === null || ref === void 0 ? void 0 : (ref1 = ref.organization) === null || ref1 === void 0 ? void 0 : ref1.id,
                scheduled: ((ref2 = context.org) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.organization) === null || ref3 === void 0 ? void 0 : ref3.achEnabled) || ((ref4 = context.org) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.organization) === null || ref5 === void 0 ? void 0 : (ref6 = ref5["organization-settings"]) === null || ref6 === void 0 ? void 0 : ref6["credit-card-payg-enabled"])
            });
        }
    }, [
        (ref1 = context.org) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.organization) === null || ref2 === void 0 ? void 0 : ref2.id,
        user
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CartBar, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CartToolBar, {
            isMobile: isMobile,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* FlexCol */.Ht, {
                    align: "center",
                    h: "88px",
                    justify: "flex-end",
                    w: "100%",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* FlexRow */.gq, {
                            align: "center",
                            justify: "space-between",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CartBadge, {
                                    badgeContent: cart === null || cart === void 0 ? void 0 : (ref3 = cart.items) === null || ref3 === void 0 ? void 0 : ref3.length,
                                    style: {
                                        cursor: "pointer",
                                        marginLeft: "48px"
                                    },
                                    onClick: showCart,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CargoVan/* CargoVanIcon */.R, {
                                        color: "cheese",
                                        w: "48px",
                                        h: "26px"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* FlexRow */.gq, {
                                    justify: "flex-end",
                                    align: "center",
                                    mr: "48px",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EstimateContainer, {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EstimateText, {
                                                    children: t("estTotal")
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EstimateAmount, {
                                                    children: (0,conversions/* formatMoney */.lb)((0,conversions/* centsToDollars */.G_)(cart === null || cart === void 0 ? void 0 : (ref4 = cart["payment-summary"]) === null || ref4 === void 0 ? void 0 : ref4.total))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonContainer, {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Button */.zx, {
                                                isFullWidth: true,
                                                "data-test-id": "btn-cart-book",
                                                size: "lg",
                                                onClick: handleClick,
                                                children: t("cart.book")
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Box */.xu, {
                            align: "center",
                            bg: "cheese",
                            color: "white",
                            h: 6,
                            mt: 2,
                            w: "100%",
                            children: ((ref5 = context.org) === null || ref5 === void 0 ? void 0 : ref5.organization) ? t("cart.limit", {
                                name: (ref6 = context.org) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.organization) === null || ref7 === void 0 ? void 0 : ref7.name,
                                maxVehicles: context === null || context === void 0 ? void 0 : (ref8 = context.org) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.organization) === null || ref9 === void 0 ? void 0 : ref9["borrow-limit"]
                            }) : ""
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Popover/* default */.ZP, {
                    marginThreshold: 0,
                    open: open,
                    PaperProps: {
                        style: (0,src_object_spread/* default */.Z)({
                            borderRadius: "10px 10px 0px 0px",
                            maxWidth: "unset"
                        }, isMobile ? {
                            width: "100%"
                        } : {})
                    },
                    style: {
                        zIndex: 20,
                        borderRadius: "10px 10px 0px 0px"
                    },
                    anchorEl: anchorEl,
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "center"
                    },
                    transformOrigin: {
                        vertical: "bottom",
                        horizontal: "center"
                    },
                    onClose: hideCart,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CartPopover, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CartMenuBar, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toolbar/* default */.Z, {
                                    style: {
                                        height: 50,
                                        minHeight: 50,
                                        paddingRight: 20
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* CloseButton */.PZ, {
                                        onClick: hideCart
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemListContainer, {
                                children: cart === null || cart === void 0 ? void 0 : (ref10 = cart.items) === null || ref10 === void 0 ? void 0 : ref10.map(function(item, idx, items) {
                                    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemCart_ItemCartCard, {
                                        pickUp: cart === null || cart === void 0 ? void 0 : cart["pick-up"],
                                        dropOff: cart === null || cart === void 0 ? void 0 : cart["drop-off"],
                                        item: item,
                                        items: items
                                    }, item === null || item === void 0 ? void 0 : item.id);
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_ItemCart = (ItemCart);

// EXTERNAL MODULE: ./node_modules/@fluidtruck/icons/dist/esm/Info.js
var Info = __webpack_require__(52636);
// EXTERNAL MODULE: ./node_modules/@fluidtruck/icons/dist/esm/Circle.js
var Circle = __webpack_require__(94204);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/ItemContainer/ItemCard.styles.js



var ItemCard_styles_mq = (0,helpers/* generateMQ */.Nt)("min");
var Container = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eao74ev0"
})(function(props) {
    return (0,src_define_property/* default */.Z)({
        backgroundColor: props.variant === "ghost" ? "#f5f5f5" : "#fff",
        borderBottom: "1px solid #C3D0D9",
        gridColumnGap: 12,
        gridRowGap: 4,
        cursor: "pointer",
        display: "grid",
        gridTemplateColumns: "120px 1fr 1fr",
        gridTemplateAreas: [
            '"image title title"',
            '"image fleet fleet"',
            '"features features features"',
            '"distance total total"',
            '"action action action"', 
        ].join(" "),
        padding: 20
    }, ItemCard_styles_mq[0], {
        gridTemplateColumns: "120px 1fr auto auto",
        gridColumnGap: 12,
        gridRowGap: 4,
        gridTemplateAreas: [
            '"image title title features"',
            '"image fleet fleet features"',
            '"image fleet fleet action"',
            '"image distance total action"',
            '"image distance total action"', 
        ].join(" ")
    });
});
var ItemCard_styles_Image = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eao74ev1"
})({
    gridArea: "image",
    "& img": {
        borderRadius: 10
    }
});
var Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eao74ev2"
})({
    fontSize: 18,
    fontWeight: 700,
    gridArea: "title",
    lineHeight: "24px"
});
var Fleet = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eao74ev3"
})({
    fontSize: 16,
    fontWeight: 700,
    gridArea: "fleet",
    lineHeight: "18px"
});
var Distance = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eao74ev4"
})({
    fontSize: 14,
    fontWeight: 700,
    gridArea: "distance",
    lineHeight: "16px",
    minHeight: 14,
    alignSelf: "flex-end"
});
var ItemCard_styles_Features = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eao74ev5"
})((0,src_define_property/* default */.Z)({
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    gridArea: "features"
}, ItemCard_styles_mq[0], {
    flexDirection: "column",
    justifyContent: "flex-start"
}));
var Feature = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eao74ev6"
})((0,src_define_property/* default */.Z)({
    "& span": {
        display: "none"
    },
    "& svg": {
        width: 20,
        height: 20,
        "&:last-of-type": {
            marginLeft: 8
        }
    }
}, ItemCard_styles_mq[0], {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    "&:first-of-type": {
        marginBottom: 8
    },
    "& span": {
        display: "inline",
        fontWeight: 700,
        fontSize: 12,
        lineHeight: "16px"
    }
}));
var Total = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eao74ev7"
})(function(props) {
    return {
        fontSize: 24,
        fontWeight: "bold",
        gridArea: "total",
        lineHeight: "24px",
        textAlign: "right",
        paddingTop: 8,
        "& div": {
            color: props.theme.colors.gray[900],
            fontSize: 14,
            fontWeight: 400,
            lineHeight: "14px"
        }
    };
});
var Action = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eao74ev8"
})((0,src_define_property/* default */.Z)({
    gridArea: "action",
    alignSelf: "end",
    textAlign: "end",
    paddingTop: 8
}, ItemCard_styles_mq[0], {
    paddingTop: 0
}));

;// CONCATENATED MODULE: ./components/ItemContainer/ItemCard.tsx

















var convertToFeetAndInches = function(num) {
    var feet = Math.floor(num);
    var inches = (num - feet) * 12;
    return "".concat(feet, "' ").concat(Math.round(inches), '"');
};
var ItemCard = function(param) {
    var itemId = param.itemId;
    var ref, ref1, ref2, ref3;
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "ev",
        "search"
    ]).t;
    var user = (0,hooks/* useUser */.aF)().user;
    var ref4 = (0,hooks/* useResize */.aB)(), isDesktop = ref4.isDesktop, isMobile = ref4.isMobile;
    var ref5 = (0,hooks/* useCart */.jD)(), cart = ref5.cart, addItemsToCart = ref5.addItemsToCart, removeItemFromCart = ref5.removeItemFromCart;
    var router = (0,next_router.useRouter)();
    var ref6 = (0,react.useState)(false), loading = ref6[0], setLoading = ref6[1];
    var ref7 = (0,hooks/* useOrganizationContext */.mP)(), _context = ref7.context, organization = _context.org.organization;
    var ref8 = (0,react.useContext)(lib_context/* ItemsContext */.ct), items = ref8.items, detailViewId = ref8.detailView.detailViewId, selectedItem = ref8.selectedItem, updateDetailView = ref8.updateDetailView, updateSelectedItem = ref8.updateSelectedItem;
    var updateEstimate = (0,lib_context/* useReservationEstimate */.Qf)().updateEstimate;
    var item = (0,react.useMemo)(function() {
        var currentItem = items === null || items === void 0 ? void 0 : items.find(function(i) {
            return i.item.id === itemId;
        });
        if (!currentItem) {
            return null;
        }
        var measurements = currentItem.measurements, _cost = currentItem.cost, cost = _cost === void 0 ? 0 : _cost;
        var cargoHeight = (measurements === null || measurements === void 0 ? void 0 : measurements["cargo-height"]) || 0;
        var cargoLength = (measurements === null || measurements === void 0 ? void 0 : measurements["cargo-length"]) || 0;
        var cargoWidth = (measurements === null || measurements === void 0 ? void 0 : measurements["cargo-width"]) || 0;
        var hasValidDimensions = cargoHeight !== 0 && cargoLength !== 0 && cargoWidth !== 0;
        var cubic = 0;
        if (hasValidDimensions) {
            cubic = cargoHeight / 12;
            cubic *= cargoLength / 12;
            cubic *= cargoWidth / 12;
        }
        return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, currentItem.item), {
            distance: currentItem === null || currentItem === void 0 ? void 0 : currentItem["distance-miles"].toFixed(2),
            cargoHeight: convertToFeetAndInches(cargoHeight),
            cargoLength: convertToFeetAndInches(cargoLength),
            cargoWidth: convertToFeetAndInches(cargoWidth),
            cost: Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD"
            }).format(cost / 100),
            cubic: cubic.toFixed(2),
            hasValidDimensions: hasValidDimensions
        });
    }, [
        itemId
    ]);
    var inCart = (0,react.useMemo)(function() {
        var ref;
        if (!cart) {
            return false;
        }
        return (cart === null || cart === void 0 ? void 0 : (ref = cart.items) === null || ref === void 0 ? void 0 : ref.find(function(i) {
            return i.id === (item === null || item === void 0 ? void 0 : item.id);
        })) !== undefined;
    }, [
        cart
    ]);
    (0,react.useEffect)(function() {
        if (isMobile && selectedItem) {
            updateSelectedItem(0);
        }
    }, [
        isMobile,
        selectedItem
    ]);
    if (!item) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
    var handleSelect = function(e) {
        var innerText = e.target.innerText;
        if (organization && (organization === null || organization === void 0 ? void 0 : organization["borrow-limit"]) <= 1 && innerText === t("common:button.reserve")) {
            router.push("/book");
            updateEstimate({
                "item-id": item.id
            });
            return;
        }
        if (detailViewId !== item.id) {
            updateDetailView({
                type: "",
                detailViewId: null
            });
        }
        if ([
            t("common:button.cancel"),
            t("common:button.remove"),
            t("common:button.add"), 
        ].includes(innerText)) {
            return;
        }
        if (isDesktop) {
            updateSelectedItem(item.id);
        }
        if (innerText === t("common:button.reserve")) {
            updateEstimate({
                "item-id": item.id
            });
            amplitude/* ampli.vehicleDetailsReserve */.iN.vehicleDetailsReserve({
                userId: user === null || user === void 0 ? void 0 : user.id
            });
            updateDetailView({
                type: "reservation",
                detailViewId: item.id,
                isAvailable: item.isAvailable
            });
        } else if (isMobile) {
            amplitude/* ampli.viewVehicleDetails */.iN.viewVehicleDetails({
                userId: user === null || user === void 0 ? void 0 : user.id
            });
            updateDetailView({
                type: "item",
                detailViewId: item.id,
                isAvailable: item.isAvailable
            });
        } else {
            amplitude/* ampli.viewVehicleOnMap */.iN.viewVehicleOnMap({
                userId: user === null || user === void 0 ? void 0 : user.id
            });
        }
    };
    var handleAddToCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var pickUp, dropOff, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        pickUp = cart === null || cart === void 0 ? void 0 : cart["pick-up"];
                        dropOff = cart === null || cart === void 0 ? void 0 : cart["drop-off"];
                        return [
                            4,
                            addItemsToCart({
                                itemIds: [
                                    item.id
                                ],
                                pickUp: pickUp,
                                dropOff: dropOff
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        setLoading(false);
                        if (response.status === "success") {
                            updateDetailView({
                                type: "",
                                detailViewId: null
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleAddToCart() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleRemoveFromCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        return [
                            4,
                            removeItemFromCart(item.id)
                        ];
                    case 1:
                        _state.sent();
                        setLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRemoveFromCart() {
            return _ref.apply(this, arguments);
        };
    }();
    var image = (item === null || item === void 0 ? void 0 : (ref = item.pictures) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.thumb) || (item === null || item === void 0 ? void 0 : (ref2 = item.pictures) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.standard) || "/img/cargo-van-square.png";
    var id = item.instabook ? "item-reserve-instabook-".concat(item.id) : "item-reserve-".concat(item.id);
    var action = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Button */.zx, {
        "data-test-id": id,
        isFullWidth: isMobile,
        isDisabled: !item.isAvailable,
        children: t("common:button.reserve")
    });
    if (cart) {
        if (inCart) {
            action = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Button */.zx, {
                "data-test-id": "item-reserve-".concat(itemId),
                isDisabled: loading,
                isFullWidth: isMobile,
                isLoading: loading,
                variant: "outline",
                onClick: handleRemoveFromCart,
                children: cart.items.length > 1 ? t("common:button.remove") : t("common:button.cancel")
            });
        } else {
            action = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Button */.zx, {
                "data-test-id": "item-add-".concat(itemId),
                isDisabled: loading || !item.isAvailable,
                isFullWidth: isMobile,
                isLoading: loading,
                onClick: handleAddToCart,
                children: t("common:button.add")
            });
        }
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
        "data-test-id": "item-card-".concat(itemId),
        onClick: handleSelect,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemCard_styles_Image, {
                children: image && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                    alt: item.title,
                    height: 768,
                    layout: "responsive",
                    quality: 100,
                    src: image,
                    width: 1024,
                    objectFit: "cover"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Title, {
                children: [
                    item.title,
                    item.hasValidDimensions && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(utils/* chakra.span */.m$.span, {
                        ml: "2px",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Tooltip */.u, {
                            label: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    "".concat(item.cargoLength, " L"),
                                    "".concat(item.cargoWidth, " W"),
                                    "".concat(item.cargoHeight, " H"), 
                                ].join(" x ")
                            }),
                            placement: "right",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Info/* InfoIcon */.s, {
                                verticalAlign: "top",
                                color: "cheese",
                                h: "24px",
                                w: "14px"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Distance, {
                children: [
                    item.distance,
                    " mi."
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemCard_styles_Features, {
                children: [
                    item.instabook && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Feature, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                children: t("common:instantBook")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InstantBook/* InstantBookIcon */.n, {
                                color: "cheese"
                            })
                        ]
                    }),
                    item["is-electric-vehicle"] && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Feature, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                children: t("ev:ev")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Circle/* CircleIcon */.J, {
                                color: "green.500"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Total, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: t("search:estTotal")
                    }),
                    item.cost
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Action, {
                children: action
            })
        ]
    });
};
/* harmony default export */ var ItemContainer_ItemCard = (ItemCard);

;// CONCATENATED MODULE: ./components/ItemContainer/itemListStyles.js


var FilterContainer = (0,utils/* chakra */.m$)(base_components/* Grid */.rj, {
    baseStyle: {
        borderTop: "1px",
        borderBottom: "1px",
        borderColor: "gray.400",
        gridColumnGap: 3,
        gridTemplateColumns: "repeat(2, auto)",
        p: {
            base: "16px 20px",
            md: "16px 20px 16px 40px"
        },
        alignItems: "center",
        justifyContent: "space-between"
    }
});
var TextDivider = (0,utils/* chakra */.m$)(base_components/* Divider */.iz, {
    baseStyle: {
        height: "18px",
        w: "1px",
        bg: "darkGray"
    }
});
var itemListStyles_ButtonContainer = (0,utils/* chakra */.m$)(base_components/* FlexRow */.gq, {
    baseStyle: {
        alignItems: {
            base: "center",
            md: "start"
        }
    }
});
var CardContainer = (0,utils/* chakra */.m$)(base_components/* Box */.xu, {
    baseStyle: {
        boxShadow: "card",
        width: "100%"
    },
    label: "CardContainer"
});
var NoResultsContainer = (0,utils/* chakra */.m$)(base_components/* Center */.M5, {
    baseStyle: {
        height: "100%"
    },
    label: "NoResultsContainer"
});

;// CONCATENATED MODULE: ./components/ItemContainer/index.jsx












var cartBar = theme/* heights.cartBar */.Db.cartBar;
var ItemContainer = function(param) {
    var isLoading = param.isLoading, showFilter = param.showFilter, handleFilterClick = param.handleFilterClick;
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "search"
    ]).t;
    var isDesktop = (0,hooks/* useResize */.aB)().isDesktop;
    var items = (0,react.useContext)(lib_context/* ItemsContext */.ct).items;
    var cart = (0,react.useContext)(lib_context/* CartContext */.A9).cart;
    var count = (items === null || items === void 0 ? void 0 : items.length) || 0;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* Box */.xu, {
                width: "100%",
                "data-test-id": "item-container",
                children: [
                    !showFilter && isDesktop && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FilterContainer, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Text */.xv, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(esm/* Trans */.cC, {
                                    t: t,
                                    i18nKey: "search:searchResults.display",
                                    count: count,
                                    children: [
                                        "Displaying ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* SpanText */.Xl, {
                                            fontWeight: "bold",
                                            children: {
                                                count: count
                                            }
                                        }),
                                        " ",
                                        "Results"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Button */.zx, {
                                "data-test-id": "filter-search",
                                leftIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Filter/* FilterIcon */.k, {
                                    h: 5,
                                    w: 5
                                }),
                                variant: "outline",
                                sx: {
                                    "> span": {
                                        marginInlineEnd: {
                                            base: 0,
                                            lg: ".5rem"
                                        }
                                    }
                                },
                                w: {
                                    base: 20
                                },
                                onClick: handleFilterClick,
                                children: t("filter")
                            })
                        ]
                    }),
                    !showFilter && !isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardContainer, {
                        pb: {
                            base: cart ? "".concat(cartBar, "px") : 0,
                            lg: 0
                        },
                        "data-test-id": "item-card-container",
                        children: [
                            items === null || items === void 0 ? void 0 : items.map(function(item) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemContainer_ItemCard, {
                                    itemId: item.item.id
                                }, item.item.id);
                            }),
                            (items === null || items === void 0 ? void 0 : items.length) === 0 && !isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoResultsContainer, {
                                "data-test-id": "no-results",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* SubHeader */.bU, {
                                    size: 16,
                                    children: t("search:noResults")
                                })
                            })
                        ]
                    })
                ]
            }),
            isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* SpinnerContainer */.eg, {})
        ]
    });
};
/* harmony default export */ var components_ItemContainer = (ItemContainer);
ItemContainer.propTypes = {
    isLoading: (prop_types_default()).bool,
    showFilter: (prop_types_default()).bool,
    handleFilterClick: (prop_types_default()).func
};

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/chakra-ui-hooks.esm.js
var chakra_ui_hooks_esm = __webpack_require__(97375);
// EXTERNAL MODULE: ./node_modules/@react-google-maps/api/dist/reactgooglemapsapi.esm.js + 3 modules
var reactgooglemapsapi_esm = __webpack_require__(25937);
// EXTERNAL MODULE: ./lib/context/GoogleMaps/reducer/map_actions.ts
var map_actions = __webpack_require__(14251);
// EXTERNAL MODULE: ./utils/maps/map-icons/electric-vehicle-location-marker.tsx
var electric_vehicle_location_marker = __webpack_require__(91196);
;// CONCATENATED MODULE: ./utils/maps/map-icons/user-location-icon.tsx
var userLocationMarker = function() {
    var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "#FFAC06";
    return '<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <circle cx="14" cy="14" r="12" fill="'.concat(color, '" stroke="#fff" stroke-width="4"></circle>\n  </svg>');
};

;// CONCATENATED MODULE: ./components/MultiVehicleMap/utils.tsx
/* provided dependency */ var Buffer = __webpack_require__(48764)["lW"];
var ClusterMarkerSvgBtoa = function(hexColor) {
    return Buffer.from('<svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="27" cy="27" r="23" fill="white" stroke="'.concat(hexColor, '" stroke-width="4"/></svg>')).toString("base64");
};

;// CONCATENATED MODULE: ./components/MultiVehicleMap/MultiVehicleMap.tsx












var options = {
    minimumClusterSize: 5,
    styles: [
        {
            url: "".concat(utils/* base64 */.US, ",").concat(ClusterMarkerSvgBtoa("#FFAC06")),
            textColor: "#FFAC06",
            textSize: 14,
            fontFamily: "Nunito Sans",
            height: 54,
            width: 54,
            fontWeight: "bold"
        },
        {
            url: "".concat(utils/* base64 */.US, ",").concat(ClusterMarkerSvgBtoa("#C9CDCF")),
            textColor: "#C9CDCF",
            textSize: 14,
            fontFamily: "Nunito Sans",
            height: 54,
            width: 54,
            fontWeight: "bold"
        }, 
    ]
};
var calculator = function(markers) {
    var someAvailable = markers.some(function(marker) {
        return marker.title === "Available";
    });
    return {
        title: "",
        text: "".concat(markers.length),
        index: someAvailable ? 1 : 2
    };
};
var MultiVehicleMap = function(param) {
    var userLocation = param.userLocation, allowZoom = param.allowZoom, onDrag = param.onDrag, onDragEnd = param.onDragEnd, handleZoom = param.handleZoom, selectedItem = param.selectedItem, handlePinCleanup = param.handlePinCleanup, infoBox = param.infoBox, items = param.items, handlePinClick = param.handlePinClick;
    var currentLocationMarker = {
        url: (0,svgToBase64/* svgToBase64 */.b)({
            icon: userLocationMarker()
        })
    };
    var ref = (0,hooks/* useGoogleMaps */.j9)(), _state = ref.state, latLng = _state.latLng, isMapLoaded = _state.isMapLoaded, dispatch = ref.dispatch, onLoad = ref.onLoad;
    if (!latLng) {
        return null;
    }
    var BoxContent = (selectedItem && infoBox || {}).BoxContent;
    // Set minHeight to 650 to avoid map shifting up on smaller screen resolutions
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(reactgooglemapsapi_esm/* GoogleMap */.b6, {
        id: "map-items-search",
        center: latLng,
        mapContainerStyle: {
            width: "inherit",
            height: "inherit",
            minHeight: "650px"
        },
        options: {
            disableDefaultUI: true,
            scrollwheel: allowZoom,
            clickableIcons: false,
            fullscreenControl: false,
            zoomControl: true
        },
        zoom: 11,
        onLoad: onLoad,
        onTilesLoaded: function() {
            dispatch({
                type: map_actions/* ACTIONS.SET_MAP_LOADED */.a.SET_MAP_LOADED,
                payload: true
            });
        },
        onDrag: onDrag,
        onDragEnd: onDragEnd,
        onZoomChanged: handleZoom,
        onUnmount: function() {
            dispatch({
                type: map_actions/* ACTIONS.SET_MAP */.a.SET_MAP,
                payload: null
            });
            dispatch({
                type: map_actions/* ACTIONS.SET_MAP_LOADED */.a.SET_MAP_LOADED,
                payload: false
            });
        },
        children: [
            selectedItem && infoBox && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(reactgooglemapsapi_esm/* InfoBox */.vD, {
                options: {
                    closeBoxURL: "",
                    alignBottom: true,
                    boxStyle: {
                        overflow: "visible"
                    },
                    disableAutoPan: false,
                    pixelOffset: new window.google.maps.Size(0, 40),
                    enableEventPropagation: true
                },
                position: {
                    lat: infoBox.position.lat,
                    lng: infoBox.position.lng
                },
                onUnmount: handlePinCleanup,
                children: BoxContent
            }),
            isMapLoaded && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(reactgooglemapsapi_esm/* MarkerClusterer */.XL, {
                maxZoom: 19,
                imageExtension: "png",
                options: options,
                calculator: calculator,
                children: function(clusterer) {
                    return items === null || items === void 0 ? void 0 : items.map(function(item) {
                        var id = item.item.id;
                        var isElectric = item.item["is-electric-vehicle"];
                        var coordinates = item.coordinates;
                        var isAvailable = item.item.isAvailable;
                        var pin = {
                            url: (0,svgToBase64/* svgToBase64 */.b)({
                                icon: isElectric ? (0,electric_vehicle_location_marker/* electricVehicleMarker */.e)(isAvailable) : (0,vehicle_location_marker/* vehicleLocationMarker */.i)(isAvailable)
                            })
                        };
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(reactgooglemapsapi_esm/* Marker */.Jx, {
                            clusterer: clusterer,
                            icon: (0,src_object_spread/* default */.Z)({}, pin),
                            position: coordinates,
                            title: "".concat(isAvailable ? "Available" : "Unavailable"),
                            onClick: function() {
                                return handlePinClick(id);
                            }
                        }, id);
                    });
                }
            }),
            userLocation && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(reactgooglemapsapi_esm/* Marker */.Jx, {
                title: "marker-user-location",
                position: {
                    lat: userLocation.lat,
                    lng: userLocation.lng
                },
                icon: (0,src_object_spread/* default */.Z)({}, currentLocationMarker)
            })
        ]
    });
};


;// CONCATENATED MODULE: ./components/MultiVehicleMap/index.tsx


;// CONCATENATED MODULE: ./components/ItemMap/helpers.jsx
var updateCenter = function(latitude, longitude, mapData) {
    var hasLargeCards = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var bounds = mapData.bounds, center = mapData.center;
    var _size = mapData.size, height = _size.height, width = _size.width;
    var neLat = bounds.ne.lat;
    var neLng = bounds.ne.lng;
    var swLat = bounds.sw.lat;
    var swLng = bounds.sw.lng;
    var latPx = (neLat - swLat) / height;
    var newLat = center.lat;
    var newLng = center.lng;
    // keep below comments for reference for stacked pins implementation later
    // const latPxOffset =  latPx * ((104 * Math.min(3, itemMultiplier)) +
    // (11 * Math.min(2, itemMultiplier - 1)) + (2 + 20 + 15 + 53));
    var latPxOffset = hasLargeCards ? latPx * 430 : latPx * 440;
    var lngPx = neLng > swLng ? (neLng - swLng) / width : (swLng - neLng) / width;
    var lngPxOffset = lngPx * 120;
    if (latitude + latPxOffset > neLng) {
        newLat = (neLat + swLat) / 2 + latitude + latPxOffset - neLat;
    }
    if (longitude + lngPxOffset > neLng) {
        if (neLng > swLng) {
            newLng = (neLng + swLng) / 2 + longitude + lngPxOffset - neLng;
        } else {
            var avg = (neLng + swLng) / 2;
            var centerLng = avg > 0 ? 180 - avg : 180 + avg;
            newLng = centerLng + longitude + lngPxOffset - neLng;
        }
    } else if (longitude - lngPxOffset < swLng) {
        if (swLng < neLng) {
            newLng = (neLng + swLng) / 2 + longitude - lngPxOffset - swLng - lngPx * 20;
        } else {
            var avg1 = (neLng + swLng) / 2;
            var centerLng1 = avg1 > 0 ? 180 - avg1 : 180 + avg1;
            newLng = centerLng1 - longitude - lngPxOffset + swLng;
        }
    }
    return {
        newLat: newLat,
        newLng: newLng
    };
};

// EXTERNAL MODULE: ./node_modules/@fluidtruck/avatar/dist/esm/avatar.js + 1 modules
var avatar = __webpack_require__(19664);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Card/Card.js
var Card = __webpack_require__(18463);
;// CONCATENATED MODULE: ./components/Reservation/ReservationManager/ManagerCard.jsx










var ManagerCard_CardContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ex9sx2w0"
})({
    boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.1), 0px 4px 8px rgba(0, 0, 0, 0.1)",
    display: "flex",
    flexDirection: "column",
    width: 184,
    position: "absolute",
    right: 0,
    bottom: 65,
    boxSizing: "border-box",
    transform: "translateX(50%)",
    zIndex: 1
});
var StyledCard = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Card/* default */.Z, {
    target: "ex9sx2w1"
})({
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%"
});
var CardContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ex9sx2w2"
})({
    padding: 9
});
var StyledHeader = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(base_components/* Header */.h4, {
    target: "ex9sx2w3"
})({
    lineHeight: "105%",
    fontSize: 16
});
var StyledSubheader = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(base_components/* Header */.h4, {
    target: "ex9sx2w4"
})({
    marginTop: 3
});
var ManagerCard = function(param) {
    var thumbnail = param.thumbnail, title = param.title, fleetNumber = param.fleetNumber, id = param.id, handleContactSupport = param.handleContactSupport, isDropOffPastNow = param.isDropOffPastNow;
    var t = (0,esm/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    var orgId = router.query.orgId;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ManagerCard_CardContainer, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCard, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(avatar/* Avatar */.q, {
                        src: thumbnail,
                        width: "100%",
                        height: "140px",
                        borderRadius: "none"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardContent, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHeader, {
                                size: 18,
                                children: title
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSubheader, {
                                size: 16,
                                children: fleetNumber
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* VStack */.gC, {
                                sx: {
                                    margin: "4px 0"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                        href: "/reservations/[orgId]/[id]/details",
                                        as: "/reservations/".concat(orgId, "/").concat(id, "/details"),
                                        children: t("button.viewRes")
                                    }),
                                    !isDropOffPastNow && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                        href: "/reservations/[orgId]/[id]/details?extend=true",
                                        as: "/reservations/".concat(orgId, "/").concat(id, "/details?extend=true"),
                                        children: t("button.extend")
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                                        href: "/messages",
                                        children: t("button.sendMsg")
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* LinkButton */.Qj, {
                                        onClick: handleContactSupport,
                                        style: {
                                            marginTop: 5
                                        },
                                        children: t("button.help")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var ReservationManager_ManagerCard = (ManagerCard);
ManagerCard.propTypes = {
    thumbnail: (prop_types_default()).string,
    title: (prop_types_default()).string,
    fleetNumber: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).number
    ]),
    id: (prop_types_default()).number,
    handleContactSupport: (prop_types_default()).func,
    isDropOffPastNow: (prop_types_default()).bool.isRequired
};

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
;// CONCATENATED MODULE: ./components/ItemMap/ItemInfo.jsx












var ItemInfo_CardContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e9bf8oc0"
})({
    boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.1), 0px 4px 8px rgba(0, 0, 0, 0.1)",
    display: "flex",
    flexDirection: "column",
    width: 184,
    position: "absolute",
    bottom: 100,
    boxSizing: "border-box",
    transform: "translateX(-50%)",
    zIndex: 1
});
var ItemInfo_StyledCard = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Card/* default */.Z, {
    target: "e9bf8oc1"
})({
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%"
});
var DistanceText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(base_components/* Header */.h4, {
    target: "e9bf8oc2"
})({
    display: "flex",
    flexDirection: "column",
    alignSelf: "flex-end",
    paddingBottom: 5
});
var TotalText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Typography/* default */.Z, {
    target: "e9bf8oc3"
})({
    alignItems: "flex-end",
    color: "#949494",
    display: "flex",
    fontFamily: "Nunito Sans",
    fontSize: 14,
    fontWeight: "normal",
    flexDirection: "column"
});
var TotalSpan = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e9bf8oc4"
})(function(props) {
    var ref, ref1;
    return {
        color: props === null || props === void 0 ? void 0 : (ref = props.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.black,
        fontSize: 16,
        fontWeight: "bold",
        fontFamily: "Nunito Sans",
        paddingLeft: 5
    };
});
var ItemInfo_CardContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e9bf8oc5"
})({
    padding: 9,
    display: "flex",
    flexDirection: "column",
    alignItems: "space-between",
    height: "100%",
    justifyContent: "space-between"
});
var ItemInfo_StyledHeader = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(base_components/* Header */.h4, {
    target: "e9bf8oc6"
})({
    lineHeight: "105%"
});
var MileageCostContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e9bf8oc7"
})({
    display: "flex",
    justifyContent: "space-between"
});
var ItemInfo_Features = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e9bf8oc8"
})({
    cursor: "pointer",
    position: "absolute",
    right: 10,
    top: 10,
    zIndex: 100
});
var InfoImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e9bf8oc9"
})(function(props) {
    return {
        background: "url(".concat(props === null || props === void 0 ? void 0 : props.src, ")"),
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: 128,
        minHeight: 128
    };
});
var ItemInfo = function(param) {
    var cost = param.cost, distance = param.distance, id = param.id, isElectric = param.isElectric, thumbnail = param.thumbnail, title = param.title, instabook = param.instabook, isAvailable = param.isAvailable;
    var updateDetailView = (0,react.useContext)(lib_context/* ItemsContext */.ct).updateDetailView;
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "search"
    ]).t;
    var user = (0,hooks/* useUser */.aF)().user;
    var formattedCost = (0,utils/* formatMoney */.lb)(cost / 100);
    var handleViewClick = function() {
        amplitude/* ampli.viewVehicleDetails */.iN.viewVehicleDetails({
            userId: user === null || user === void 0 ? void 0 : user.id
        });
        updateDetailView({
            type: "item",
            detailViewId: id,
            isAvailable: isAvailable
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemInfo_CardContainer, {
        "data-test-id": "card-item-info-".concat(id),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemInfo_StyledCard, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoImage, {
                    src: thumbnail
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemInfo_Features, {
                    children: [
                        isElectric && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EVBadge/* EVBadgeIcon */.T, {
                            h: 5,
                            mr: 2,
                            w: 5
                        }),
                        instabook && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InstantBook/* InstantBookIcon */.n, {
                            color: "cheese",
                            h: 5,
                            w: 5
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemInfo_CardContent, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemInfo_StyledHeader, {
                                    size: 18,
                                    children: title
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MileageCostContainer, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DistanceText, {
                                            size: 14,
                                            children: [
                                                distance.toFixed(2),
                                                " mi"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TotalText, {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(esm/* Trans */.cC, {
                                                t: t,
                                                i18nKey: "search:map.itemPinEst",
                                                children: [
                                                    "Estimated Total",
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TotalSpan, {
                                                        children: {
                                                            cost: formattedCost
                                                        }
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* SubmitButton */.Mm, {
                            mt: 3,
                            "data-test-id": "button-view-".concat(id),
                            onClick: handleViewClick,
                            children: t("button.view")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ItemMap_ItemInfo = (ItemInfo);
ItemInfo.propTypes = {
    cost: (prop_types_default()).number,
    distance: (prop_types_default()).number,
    id: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).number
    ]),
    isElectric: (prop_types_default()).bool,
    thumbnail: (prop_types_default()).string,
    title: (prop_types_default()).string,
    instabook: (prop_types_default()).bool
};

;// CONCATENATED MODULE: ./components/ItemMap/ItemPin.jsx









var ItemPinContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "errhaph0"
})(function() {
    return {
        label: "ItemPinContainer"
    };
});
var ItemPin = function(param) {
    var thumbnail = param.thumbnail, title = param.title, cost = param.cost, fleetNumber = param.fleetNumber, isElectric = param.isElectric, isReservationsPage = param.isReservationsPage, id = param.id, distance = param.distance, handleContactSupport = param.handleContactSupport, instabook = param.instabook, isDropOffPastNow = param.isDropOffPastNow, isAvailable = param.isAvailable;
    var selectedItem = (0,react.useContext)(lib_context/* ItemsContext */.ct).selectedItem;
    var itemInfo = {
        cost: cost,
        distance: distance,
        fleetNumber: fleetNumber,
        id: id,
        isElectric: isElectric,
        thumbnail: thumbnail,
        title: title,
        instabook: instabook,
        isDropOffPastNow: isDropOffPastNow,
        isAvailable: isAvailable
    };
    var isShown = selectedItem === id;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemPinContainer, {
        "data-test-id": "item-pin-".concat(id),
        children: [
            isShown && !isReservationsPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemMap_ItemInfo, (0,src_object_spread/* default */.Z)({}, itemInfo)),
            isShown && isReservationsPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReservationManager_ManagerCard, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, itemInfo), {
                handleContactSupport: handleContactSupport
            }))
        ]
    });
};
/* harmony default export */ var ItemMap_ItemPin = (ItemPin);
ItemPin.propTypes = {
    thumbnail: (prop_types_default()).string,
    title: (prop_types_default()).string,
    cost: (prop_types_default()).number,
    fleetNumber: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).number
    ]),
    onClick: (prop_types_default()).func,
    isElectric: (prop_types_default()).bool,
    isReservationsPage: (prop_types_default()).bool,
    id: (prop_types_default()).number,
    distance: (prop_types_default()).number,
    handleContactSupport: (prop_types_default()).func,
    instabook: (prop_types_default()).bool,
    isDropOffPastNow: (prop_types_default()).bool
};
ItemPin.defaultProps = {
    cost: 0,
    isElectric: false,
    isReservationsPage: false,
    isDropOffPastNow: false
};

;// CONCATENATED MODULE: ./components/ItemMap/styles.tsx


// SEARCH BUTTON
var SearchAreaButton = (0,utils/* chakra */.m$)(base_components/* Button */.zx, {
    baseStyle: {
        position: "absolute",
        left: "50%",
        marginLeft: "-75px",
        top: {
            base: 3,
            lg: 4
        },
        zIndex: "mapOverlay"
    }
});

;// CONCATENATED MODULE: ./components/ItemMap/index.jsx
















var ItemMap = function(param) {
    var isLoading = param.isLoading;
    var ref, ref1, ref2;
    var t = (0,esm/* useTranslation */.$G)("search").t;
    var isGoogleLoaded = (0,hooks/* useGoogleMapsApi */.Bk)().isGoogleLoaded;
    var ref3 = (0,hooks/* useGoogleMaps */.j9)(), _state = ref3.state, zoom = _state.zoom, latLng = _state.latLng, mapInstance = _state.mapInstance, isMapLoaded = _state.isMapLoaded, dispatch = ref3.dispatch, setMapLatLng = ref3.setMapLatLng;
    var ref4 = (0,react.useContext)(lib_context/* ItemsContext */.ct), _items = ref4.items, items = _items === void 0 ? [] : _items, updateMapLocation = ref4.updateMapLocation, mapLocation = ref4.mapLocation, updateSelectedItem = ref4.updateSelectedItem, selectedItem = ref4.selectedItem, userLocation = ref4.userLocation;
    var prevSelectedItem = (0,chakra_ui_hooks_esm/* usePrevious */.D9)(selectedItem);
    var ref5 = (0,react.useState)(false), searchButtonVisible = ref5[0], setSearchButtonVisible = ref5[1];
    var ref6 = (0,react.useState)(true), allowZoom = ref6[0], setAllowZoom = ref6[1];
    var selectedPin = items.find(function(item) {
        return item.item.id === selectedItem;
    });
    (0,react.useEffect)(function updatedSelectedItemView() {
        if (prevSelectedItem === selectedItem || !selectedItem) return;
        var getBounds = mapInstance === null || mapInstance === void 0 ? void 0 : mapInstance.getBounds();
        var mapData = {
            bounds: {
                ne: {
                    lat: getBounds.getNorthEast().lat(),
                    lng: getBounds.getNorthEast().lng()
                },
                sw: {
                    lat: getBounds.getSouthWest().lat(),
                    lng: getBounds.getSouthWest().lng()
                }
            },
            center: {
                lat: getBounds.getCenter().lat(),
                lng: getBounds.getCenter().lng()
            },
            size: {
                width: mapInstance.getDiv().offsetWidth,
                height: mapInstance.getDiv().offsetHeight
            },
            zoom: zoom
        };
        var ref = updateCenter(selectedPin.coordinates.lat, selectedPin.coordinates.lng, mapData), newLat = ref.newLat, newLng = ref.newLng;
        dispatch({
            type: map_actions/* ACTIONS.SET_LATLNG */.a.SET_LATLNG,
            payload: {
                lat: newLat,
                lng: newLng
            }
        });
    }, [
        dispatch,
        mapInstance,
        prevSelectedItem,
        selectedItem,
        selectedPin === null || selectedPin === void 0 ? void 0 : selectedPin.coordinates.lat,
        selectedPin === null || selectedPin === void 0 ? void 0 : selectedPin.coordinates.lng,
        zoom, 
    ]);
    var handleSearchButton = function() {
        setSearchButtonVisible(false);
        var center = mapInstance.getBounds().getCenter();
        var mapLat = center.lat();
        var mapLng = center.lng();
        updateMapLocation((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, mapLocation), {
            lat: mapLat,
            lng: mapLng
        }));
    };
    if (!latLng) {
        return null;
    }
    var handleDragEnd = function() {
        if (!mapInstance) return;
        setMapLatLng();
        setSearchButtonVisible(true);
    };
    var handleDrag = function() {
        if (selectedItem) updateSelectedItem();
    };
    var handleZoom = function() {
        var isNotUserZoomClick = !isMapLoaded || !zoom;
        if (isNotUserZoomClick) return;
        setSearchButtonVisible(true);
    };
    var handlePinClick = function(id) {
        updateSelectedItem(id);
        setAllowZoom(false);
    };
    var handlePinCleanup = function() {
        updateSelectedItem(0);
        setAllowZoom(true);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((style_default()), {
                id: "f1929b70680e81c3",
                children: ".gm-style-pbc+div{-webkit-box-shadow:inset 4px 4px 4px -4px rgba(0,0,0,.4),inset 0 -4px 4px -4px rgba(0,0,0,.4);-moz-box-shadow:inset 4px 4px 4px -4px rgba(0,0,0,.4),inset 0 -4px 4px -4px rgba(0,0,0,.4);box-shadow:inset 4px 4px 4px -4px rgba(0,0,0,.4),inset 0 -4px 4px -4px rgba(0,0,0,.4)}"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* Box */.xu, {
                h: "100%",
                position: "relative",
                w: "100%",
                children: [
                    searchButtonVisible && !selectedItem && !isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchAreaButton, {
                        "data-test-id": "button-search-area",
                        onClick: handleSearchButton,
                        children: t("searchArea")
                    }),
                    isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* FlexRow */.gq, {
                        alignContent: "center",
                        justifyContent: "center",
                        height: "100%",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* SpinnerContainer */.eg, {})
                    }),
                    isGoogleLoaded && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MultiVehicleMap, {
                        userLocation: userLocation,
                        allowZoom: allowZoom,
                        handleZoom: handleZoom,
                        selectedItem: selectedItem,
                        handlePinCleanup: handlePinCleanup,
                        infoBox: selectedPin && {
                            position: selectedPin.coordinates,
                            BoxContent: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemMap_ItemPin, {
                                id: selectedPin.item.id,
                                distance: selectedPin["distance-miles"],
                                cost: selectedPin.cost,
                                title: selectedPin.item.title,
                                thumbnail: ((ref = selectedPin.item.pictures) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.thumb) || ((ref2 = selectedPin.item.pictures) === null || ref2 === void 0 ? void 0 : ref2[0].standard),
                                isElectric: selectedPin.item["is-electric-vehicle"],
                                fleetNumber: selectedPin.item["fleet-number"],
                                instabook: selectedPin.item.instabook,
                                isAvailable: selectedPin.item.isAvailable,
                                onClick: handlePinClick
                            })
                        },
                        items: items,
                        handlePinClick: handlePinClick,
                        onDragEnd: handleDragEnd,
                        onDrag: handleDrag
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_ItemMap = (ItemMap);
ItemMap.propTypes = {
    isLoading: (prop_types_default()).bool
};

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./components/PromoCode.jsx
var PromoCode = __webpack_require__(64198);
// EXTERNAL MODULE: ./components/RequiredActionsCard/index.ts + 1 modules
var RequiredActionsCard = __webpack_require__(45189);
// EXTERNAL MODULE: ./components/Reservation/LineItemStyles.jsx
var LineItemStyles = __webpack_require__(49435);
// EXTERNAL MODULE: ./components/Reservation/ReservationSummary/helpers.js
var ReservationSummary_helpers = __webpack_require__(61706);
;// CONCATENATED MODULE: ./components/Reservation/ReservationSummary/SummaryDurationSearch.jsx






var DurationContainer = (0,chakra_ui_system_esm/* chakra */.m$)("div", {
    baseStyle: {
        display: "flex",
        justifyContent: "space-evenly",
        border: "1px",
        borderColor: "keylineGray",
        borderRadius: "base",
        marginBottom: 2,
        gap: 3
    },
    label: "DurationContainer"
});
var TimeContainer = (0,chakra_ui_system_esm/* chakra */.m$)("div", {
    baseStyle: {
        textAlign: "center",
        my: 3
    },
    label: "TimeContainer"
});
var SummaryDurationSearch = function(param) {
    var pickUp = param.pickUp, dropOff = param.dropOff;
    var t = (0,esm/* useTranslation */.$G)().t;
    var pickupMoment = moment_default()(pickUp).startOf("h");
    var dropoffMoment = moment_default()(dropOff).startOf("h");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DurationContainer, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TimeContainer, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* GrayText */.IK, {
                        fontSize: "md",
                        children: t("pickup")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Text */.xv, {
                        mt: "2",
                        children: pickupMoment.format("MM/DD/YY")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* SubHeading */.GL, {
                        fontWeight: "normal",
                        children: pickupMoment.format("hh:mma")
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_system_esm/* chakra.div */.m$.div, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Divider */.iz, {
                    orientation: "vertical",
                    borderColor: "keylineGray"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TimeContainer, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* GrayText */.IK, {
                        fontSize: "md",
                        children: t("return")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Text */.xv, {
                        mt: "2",
                        children: dropoffMoment.format("MM/DD/YY")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* SubHeading */.GL, {
                        fontWeight: "normal",
                        children: dropoffMoment.format("hh:mma")
                    })
                ]
            })
        ]
    });
};
SummaryDurationSearch.propTypes = {
    pickUp: prop_types_default().oneOfType([
        (prop_types_default()).object,
        (prop_types_default()).string
    ]),
    dropOff: prop_types_default().oneOfType([
        (prop_types_default()).object,
        (prop_types_default()).string
    ])
};
SummaryDurationSearch.defaultProps = {
    pickUp: new Date(),
    dropOff: new Date()
};
/* harmony default export */ var ReservationSummary_SummaryDurationSearch = ((/* unused pure expression or super */ null && (SummaryDurationSearch)));

// EXTERNAL MODULE: ./components/Reservation/ReservationSummary/SummaryLogin.tsx
var SummaryLogin = __webpack_require__(52428);
;// CONCATENATED MODULE: ./components/Reservation/ReservationSummary/SearchSummary/styles.ts





var styles_mqMax = (0,helpers/* generateMQ */.Nt)("max");
var styles_SmallText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(base_components/* SubHeader */.bU, {
    target: "e1c3rszr0"
})(function(props) {
    var ref, ref1;
    return (0,src_define_property/* default */.Z)({
        color: props === null || props === void 0 ? void 0 : (ref = props.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.gray[900],
        display: "flex",
        alignItems: "flex-end"
    }, styles_mqMax[0], {
        fontSize: 14
    });
});
var styles_DividerContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1c3rszr1"
})({
    display: "flex",
    alignItems: "flex-end",
    marginBottom: 3
});
var styles_MileageContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1c3rszr2"
})({
    display: "flex",
    paddingTop: 11
});
var styles_StyledDivider = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Divider_Divider/* default */.Z, {
    target: "e1c3rszr3"
})(function(props) {
    var ref, ref1;
    return {
        backgroundColor: props === null || props === void 0 ? void 0 : (ref = props.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.gray[700],
        margin: "0 8px"
    };
});

;// CONCATENATED MODULE: ./components/Reservation/ReservationSummary/SearchSummary/SubmitSection.tsx



var SubmitSection = function(param) {
    var methods = param.methods, state = param.state;
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "search"
    ]).t;
    var isInCart = function() {
        var itemIds = (state.cartItems || []).map(function(i) {
            return i === null || i === void 0 ? void 0 : i.id;
        });
        return itemIds.includes(state.detailViewId);
    }();
    var submitSection = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* Box */.xu, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* ButtonGroup */.hE, {
                mt: 6,
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Button */.zx, {
                        isFullWidth: true,
                        "data-test-id": "button-add-vehicle",
                        onClick: methods.handleCreateCart,
                        className: "search-item-reserve-addmore",
                        variant: "outline",
                        children: t("search:cart.addMore")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Button */.zx, {
                        isFullWidth: true,
                        "data-test-id": "button-continue",
                        onClick: methods.handleContinue,
                        className: "search-item-reserve-submit",
                        children: t("search:cart.continue")
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* MidText */.Jc, {
                mt: 4,
                textAlign: "center",
                children: t("search:cart.notYet")
            })
        ]
    });
    if (state.cartId) {
        submitSection = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* Box */.xu, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* Button */.zx, {
                    onClick: methods.handleAddItemToCart,
                    children: [
                        " ",
                        t("common:button.add")
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* MidText */.Jc, {
                    mt: 4,
                    textAlign: "center",
                    children: t("search:cart.notYet")
                })
            ]
        });
    }
    if (isInCart) {
        submitSection = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Box */.xu, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Button */.zx, {
                isFullWidth: true,
                onClick: methods.handleRemoveItemFromCart,
                variant: "outline",
                children: t("search:cart.remove")
            })
        });
    }
    return submitSection;
};

;// CONCATENATED MODULE: ./components/Reservation/ReservationSummary/SearchSummary/SearchSummary.jsx





























var SearchSummary_topNavMobile = theme/* heights.topNavMobile */.Db.topNavMobile;
var SearchSummary = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var router = (0,next_router.useRouter)();
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "search"
    ]).t;
    // state
    var ref7 = (0,chakra_ui_hooks_esm/* useDisclosure */.qY)(), loginOpen = ref7.isOpen, setLoginOpen = ref7.onOpen, closeLogin = ref7.onClose;
    var ref8 = (0,react.useState)({}), loc = ref8[0], setLoc = ref8[1];
    // hooks
    var user = (0,hooks/* useUser */.aF)().user;
    var isMobile = (0,hooks/* useResize */.aB)().isMobile;
    // context
    var ref9 = (0,hooks/* useOrganizationContext */.mP)(), org = ref9.context.org;
    var organizations = (0,hooks/* useOrgBilling */.it)().organizations;
    var ref10 = (0,hooks/* useCart */.jD)(), cart = ref10.cart, addItemsToCart = ref10.addItemsToCart, createCart = ref10.createCart, removeItemFromCart = ref10.removeItemFromCart;
    var showFeedback = (0,react.useContext)(lib_context/* FeedbackContext */.l).showFeedback;
    var updateLoading = (0,react.useContext)(lib_context/* LoadingContext */.pV).updateLoading;
    var itemsContext = (0,react.useContext)(lib_context/* ItemsContext */.ct);
    var detailView = itemsContext.detailView, searchInfo = itemsContext.searchInfo, updateDetailView = itemsContext.updateDetailView, updateSelectedItem = itemsContext.updateSelectedItem;
    var ref11 = (0,hooks/* useOrgDocuments */.fu)(), tmp = ref11.org, documents = (tmp === void 0 ? {} : tmp).documents;
    var detailViewId = detailView === null || detailView === void 0 ? void 0 : detailView.detailViewId;
    // constants
    var authenticated = (user === null || user === void 0 ? void 0 : user.email) != null;
    var stepOneComplete = (user === null || user === void 0 ? void 0 : user.first) != null && (user === null || user === void 0 ? void 0 : user.last) != null;
    var stepTwoComplete = user === null || user === void 0 ? void 0 : user["phone-number-verified"];
    var stepThreeComplete = (user === null || user === void 0 ? void 0 : user.organizations.reduce(function(bm, o) {
        return bm.concat(o === null || o === void 0 ? void 0 : o["billing-methods"]);
    }, []).length) > 0;
    var internalOrgType = org === null || org === void 0 ? void 0 : (ref = org.organization) === null || ref === void 0 ? void 0 : ref["organization-settings"]["internal-type"];
    var orgId = org === null || org === void 0 ? void 0 : org.id;
    var requiredActionsArray = function() {
        var ref;
        var arr = [];
        if (!(documents === null || documents === void 0 ? void 0 : documents.some(function(doc) {
            return doc["type"] === "insurance";
        }))) {
            arr.push({
                action: t("search:insuranceAlert.uploadCertificateInsurance"),
                link: "/account/organization/".concat(orgId)
            });
        }
        if ((user === null || user === void 0 ? void 0 : (ref = user.identification) === null || ref === void 0 ? void 0 : ref.status) !== "verified") {
            arr.push({
                action: t("search:insuranceAlert.uploadLicense"),
                link: "/account"
            });
        }
        return arr;
    };
    var ref12 = (0,lib_context/* useReservationEstimate */.Qf)(), reservationEstimate = ref12.reservationEstimate, updateEstimate = ref12.updateEstimate, errorMessage = ref12.errorMessage;
    var methods = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            "pick-up": moment_default()(searchInfo === null || searchInfo === void 0 ? void 0 : searchInfo.start).toISOString(),
            "drop-off": moment_default()(searchInfo === null || searchInfo === void 0 ? void 0 : searchInfo.end).toISOString(),
            "promo-code": ""
        }
    });
    var watch = methods.watch, getValues = methods.getValues;
    var promoCode = watch("promo-code");
    var ref13 = (0,core/* default */.ZP)(detailViewId ? "api/publicitems/".concat(detailViewId) : null, helpers/* get */.U2), itemData = ref13.data;
    var loadLocation = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,utils_location/* currentLocation */.DX)()
                        ];
                    case 1:
                        res = _state.sent();
                        setLoc(res);
                        return [
                            2
                        ];
                }
            });
        });
        return function loadLocation() {
            return _ref.apply(this, arguments);
        };
    }();
    var updatePromo = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var formValues;
            return (0,tslib_es6.__generator)(this, function(_state) {
                formValues = getValues();
                updateEstimate({
                    "promo-code": formValues === null || formValues === void 0 ? void 0 : formValues["promo-code"].toLocaleUpperCase()
                });
                return [
                    2
                ];
            });
        });
        return function updatePromo() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleContinue = function() {
        amplitude/* ampli.continueToBook */.iN.continueToBook();
        if (!authenticated) {
            router.push("/account/signup?booking=true");
        } else if (authenticated && !stepOneComplete) {
            router.push("/account/create?booking=true");
        } else if (authenticated && !stepTwoComplete) {
            router.push("/account/create/phone?booking=true");
        } else if (authenticated && !stepThreeComplete) {
            router.push("/account/create/billing_method?booking=true");
        } else if (authenticated) {
            var ref, ref1;
            router.push("/book");
            amplitude/* ampli.viewBookingReviewPage */.iN.viewBookingReviewPage({
                userId: user === null || user === void 0 ? void 0 : user.id,
                orgId: org === null || org === void 0 ? void 0 : (ref = org.organization) === null || ref === void 0 ? void 0 : ref.id,
                hasBookingCart: false,
                reservationEndTime: reservationEstimate === null || reservationEstimate === void 0 ? void 0 : reservationEstimate["drop-off"],
                reservationStartTime: reservationEstimate === null || reservationEstimate === void 0 ? void 0 : reservationEstimate["pick-up"],
                itemIds: [
                    reservationEstimate === null || reservationEstimate === void 0 ? void 0 : (ref1 = reservationEstimate.item) === null || ref1 === void 0 ? void 0 : ref1.id
                ],
                promoCode: promoCode || "",
                deviceType: isMobile ? "web-mobile" : "web-desktop"
            });
        }
    };
    var handleAddItemToCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var pickUp, dropOff, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        updateLoading(true);
                        pickUp = moment_default()(searchInfo === null || searchInfo === void 0 ? void 0 : searchInfo.start).toISOString();
                        dropOff = moment_default()(searchInfo === null || searchInfo === void 0 ? void 0 : searchInfo.end).toISOString();
                        return [
                            4,
                            addItemsToCart({
                                itemIds: [
                                    detailViewId
                                ],
                                pickUp: pickUp,
                                dropOff: dropOff
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        updateLoading(false);
                        if (response.status === "success") {
                            updateDetailView({
                                type: "",
                                detailViewId: null
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleAddItemToCart() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleRemoveItemFromCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        updateLoading(true);
                        return [
                            4,
                            removeItemFromCart(detailViewId)
                        ];
                    case 1:
                        _state.sent();
                        updateLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRemoveItemFromCart() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCreateCart = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var defaultOrgId, defaultOrgProfile, defaultOrg, defaultBorrowLimit, fallbackOrgProfile, fallbackOrg, bookingOrg, formValues, pickUp, dropOff, billingId, organizationId, response, ref, ref1, serverMessage, message;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    amplitude/* ampli.addVehicleAndBookMore */.iN.addVehicleAndBookMore();
                    if (!user) {
                        setLoginOpen();
                        return [
                            2
                        ];
                    }
                    defaultOrgId = user["default-organization-id"];
                    defaultOrgProfile = user.organizations.find(function(param) {
                        var organization = param.organization;
                        return organization.id === defaultOrgId;
                    });
                    defaultOrg = defaultOrgProfile.organization;
                    defaultBorrowLimit = defaultOrg["borrow-limit"];
                    fallbackOrgProfile = user.organizations.find(function(param) {
                        var organization = param.organization, profile = param.profile;
                        return organization["borrow-limit"] > 1 && profile.role !== "driver";
                    });
                    fallbackOrg = fallbackOrgProfile === null || fallbackOrgProfile === void 0 ? void 0 : fallbackOrgProfile.organization;
                    bookingOrg = defaultBorrowLimit > 1 ? defaultOrg : fallbackOrg;
                    if (!bookingOrg) return [
                        3,
                        2
                    ];
                    updateLoading(true);
                    formValues = getValues();
                    pickUp = searchInfo.start.toISOString();
                    dropOff = searchInfo.end.toISOString();
                    billingId = bookingOrg["default-billing-method-id"];
                    organizationId = bookingOrg.id;
                    return [
                        4,
                        createCart({
                            billingId: billingId,
                            dropOff: dropOff,
                            itemId: detailViewId,
                            location: loc,
                            organizationId: organizationId,
                            pickUp: pickUp,
                            promoCode: formValues["promo-code"],
                            loc: loc,
                            vehicleType: searchInfo.type
                        })
                    ];
                case 1:
                    response = _state.sent();
                    updateLoading(false);
                    try {
                        if ((response === null || response === void 0 ? void 0 : response.status) !== "success") throw new Error();
                        updateSelectedItem(0);
                        updateEstimate({
                            "item-id": 0
                        });
                        updateDetailView({
                            type: "",
                            detailViewId: null
                        });
                    } catch (e) {
                        ;
                        serverMessage = response === null || response === void 0 ? void 0 : (ref1 = response.messages) === null || ref1 === void 0 ? void 0 : ref1[(response === null || response === void 0 ? void 0 : (ref = response.messages) === null || ref === void 0 ? void 0 : ref.length) - 1];
                        message = serverMessage;
                        if (serverMessage === "item must be instabook to add to cart") {
                            message = t("search:cart.error.insta");
                        } else if (serverMessage === "adding this item will surpass your vehicle borrow limit") {
                            message = t("search:cart.error.limit");
                        }
                        showFeedback(message, "error");
                    }
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        user,
        setLoginOpen,
        updateLoading,
        getValues,
        searchInfo.start,
        searchInfo.end,
        searchInfo.type,
        createCart,
        detailViewId,
        loc,
        updateSelectedItem,
        updateEstimate,
        updateDetailView,
        showFeedback,
        t, 
    ]);
    var submitSectionProps = {
        methods: {
            handleAddItemToCart: handleAddItemToCart,
            handleContinue: handleContinue,
            handleCreateCart: handleCreateCart,
            handleRemoveItemFromCart: handleRemoveItemFromCart
        },
        state: {
            detailViewId: detailViewId,
            cartItems: cart === null || cart === void 0 ? void 0 : cart.items,
            cartId: cart === null || cart === void 0 ? void 0 : cart["cart-id"]
        }
    };
    var handleLoginCallback = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            handleCreateCart()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleLoginCallback() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        loadLocation();
    }, []);
    (0,react.useEffect)(function() {
        if (loginOpen) {
            var url = "api/v1/organizations/profiles/billing_methods";
            (0,core/* mutate */.JG)(url, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                var info;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,helpers/* get */.U2)(url, user)
                            ];
                        case 1:
                            info = _state.sent();
                            return [
                                2,
                                info
                            ];
                    }
                });
            }));
            closeLogin();
            handleCreateCart();
        }
    }, [
        user,
        loginOpen,
        closeLogin,
        handleCreateCart
    ]);
    (0,react.useEffect)(function() {
        if (loginOpen && (organizations === null || organizations === void 0 ? void 0 : organizations.length) > 0) {
            closeLogin();
            handleCreateCart();
        }
    }, [
        organizations,
        loginOpen,
        closeLogin,
        handleCreateCart
    ]);
    var ref14 = (reservationEstimate === null || reservationEstimate === void 0 ? void 0 : reservationEstimate.invoice) || {}, invoicePayments = ref14["invoice-payments"];
    var taxLineItems = invoicePayments ? (0,ReservationSummary_helpers/* getTaxLineItems */.u3)(invoicePayments) : null;
    var totalTax = (0,ReservationSummary_helpers/* getTotalTaxAmount */.us)(invoicePayments);
    var requiredActions = requiredActionsArray();
    var getVariant = (0,hooks/* useExperiment */.aq)().getVariant;
    var coiExperiment = getVariant("fluid-7389-coi-warning");
    var coiFlagActive = (coiExperiment === null || coiExperiment === void 0 ? void 0 : coiExperiment.value) === "show";
    var showRequiredActionsCard = requiredActions.length > 0 && internalOrgType !== "Fedex Express" && internalOrgType !== "UPS" && coiFlagActive;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, methods), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* FlexCol */.Ht, {
                "data-test-id": "search-summary-container",
                width: "100%",
                p: 5,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* FlexCol */.Ht, {
                    "data-test-id": "search-summary-container-inner",
                    mb: {
                        base: "".concat(SearchSummary_topNavMobile, "px"),
                        lg: 0
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SummaryDurationSearch, {
                            pickUp: (0,conversions/* withCurrentTimezone */.R5)(searchInfo === null || searchInfo === void 0 ? void 0 : searchInfo.start),
                            dropOff: (0,conversions/* withCurrentTimezone */.R5)(searchInfo === null || searchInfo === void 0 ? void 0 : searchInfo.end)
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles_MileageContainer, {
                            children: (itemData === null || itemData === void 0 ? void 0 : (ref1 = itemData.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.details) === null || ref2 === void 0 ? void 0 : ref2.unlimited_miles) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles_SmallText, {
                                size: 16,
                                children: t("common:unlimitedMileage")
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles_SmallText, {
                                        size: 16,
                                        children: t("search:includedMilage", {
                                            mileage: reservationEstimate === null || reservationEstimate === void 0 ? void 0 : (ref3 = reservationEstimate.item) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.details) === null || ref4 === void 0 ? void 0 : ref4.mileage_limit_daily
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles_DividerContainer, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styles_StyledDivider, {
                                            orientation: "vertical",
                                            style: {
                                                height: 17
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(styles_SmallText, {
                                        size: 16,
                                        children: [
                                            (0,conversions/* formatMoney */.lb)((0,conversions/* centsToDollars */.G_)(reservationEstimate === null || reservationEstimate === void 0 ? void 0 : (ref5 = reservationEstimate.item) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.details) === null || ref6 === void 0 ? void 0 : ref6.cost_per_mile)),
                                            " ",
                                            t("search:perAdditionalMile")
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LineItemStyles/* Estimate */.B0, {
                            amount: (0,ReservationSummary_helpers/* lineItemAmount */.eO)(reservationEstimate, "estimate")
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LineItemStyles/* PremiumMaintenance */.Qx, {
                            amount: (0,ReservationSummary_helpers/* lineItemAmount */.eO)(reservationEstimate, "premium_maintenance")
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LineItemStyles/* ServiceFee */.Wz, {
                            amount: (0,ReservationSummary_helpers/* lineItemAmount */.eO)(reservationEstimate, "booking_fee")
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LineItemStyles/* Deposit */.z5, {
                            amount: (0,ReservationSummary_helpers/* lineItemAmount */.eO)(reservationEstimate, "deposit")
                        }),
                        !!totalTax && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LineItemStyles/* SalesTaxLineItem */.AO, {
                            amount: totalTax,
                            lineItems: taxLineItems
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LineItemStyles/* UserCredit */.Ci, {
                            amount: (0,ReservationSummary_helpers/* creditAmount */.Gi)(reservationEstimate)
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PromoCode/* default */.Z, {
                            amount: (0,ReservationSummary_helpers/* lineItemAmount */.eO)(reservationEstimate, "promo"),
                            error: errorMessage,
                            onClick: updatePromo
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* FlexRow */.gq, {
                            justify: "space-between",
                            align: "center",
                            mt: 6,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* SubHeading */.GL, {
                                    children: t("total")
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* SubHeading */.GL, {
                                    children: (0,ReservationSummary_helpers/* totalAmount */.Fu)(reservationEstimate)
                                })
                            ]
                        }),
                        showRequiredActionsCard && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* FlexRow */.gq, {
                            mt: 5,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RequiredActionsCard/* RequiredActionsCard */.z, {
                                requiredActions: requiredActions
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubmitSection, (0,src_object_spread/* default */.Z)({}, submitSectionProps))
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* ModalGroup */.VT, {
                isOpen: loginOpen,
                title: t("login.logIn"),
                onClose: closeLogin,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SummaryLogin/* default */.Z, {
                    onFinish: handleLoginCallback
                })
            })
        ]
    }));
};
/* harmony default export */ var SearchSummary_SearchSummary = (SearchSummary);

;// CONCATENATED MODULE: ./components/Reservation/ReservationSummary/SearchSummary/index.ts


// EXTERNAL MODULE: ./node_modules/@chakra-ui/tabs/dist/chakra-ui-tabs.esm.js
var chakra_ui_tabs_esm = __webpack_require__(73465);
// EXTERNAL MODULE: ./node_modules/@fluidtruck/icons/dist/esm/Close.js
var Close = __webpack_require__(17661);
// EXTERNAL MODULE: ./base-components/forms/ItemSearchSelect/index.ts + 2 modules
var ItemSearchSelect = __webpack_require__(6997);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/chakra-ui-media-query.esm.js
var chakra_ui_media_query_esm = __webpack_require__(92684);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Alert/Alert.js + 4 modules
var Alert = __webpack_require__(8936);
// EXTERNAL MODULE: ./components/LocationAutocomplete/index.ts + 1 modules
var LocationAutocomplete = __webpack_require__(95968);
// EXTERNAL MODULE: ./features/search/weekCalculator/useWeekCalculator.ts
var useWeekCalculator = __webpack_require__(24278);
// EXTERNAL MODULE: ./features/search/weekCalculator/WeekCalculator.tsx + 1 modules
var WeekCalculator = __webpack_require__(68189);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputLabel/InputLabel.js
var InputLabel = __webpack_require__(96394);
;// CONCATENATED MODULE: ./components/SearchBar/searchBarStyles.js




var searchBarStyles_mq = (0,helpers/* generateMQ */.Nt)("max");
var searchFormStyles = {
    width: "100%",
    justifyContent: "center",
    height: "100%",
    alignItems: "center",
    position: "relative",
    boxShadow: {
        base: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        lg: "0px 4px 8px rgba(0, 0, 0, 0.1), 0px 0px 6px rgba(0, 0, 0, 0.1)"
    },
    padding: {
        base: "16px 20px",
        lg: 0
    }
};
var TypeContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eazuhm80"
})((0,src_define_property/* default */.Z)({
    width: 180,
    paddingRight: 16
}, searchBarStyles_mq[0], {
    width: "100%",
    paddingRight: 0
}));
var LocationContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eazuhm81"
})((0,src_define_property/* default */.Z)({
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    width: 220,
    maxHeight: 48,
    margin: "0 16px",
    "& div div div": {
        zIndex: 20
    },
    "& .MuiAutocomplete-root": {},
    ".MuiInput-underline:after": {
        borderBottom: "none"
    },
    "& .MuiInputBase-input": {
        width: "100%"
    },
    "& .MuiAutocomplete-popupIndicator": {
        display: "none"
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiInput-root"] ': {
        paddingBottom: 0
    }
}, searchBarStyles_mq[0], {
    width: "100%",
    alignItems: "normal",
    margin: 0
}));
var DeliveryContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eazuhm82"
})({
    marginRight: 16
});
var LocationLabel = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(InputLabel/* default */.Z, {
    target: "eazuhm83"
})(function(props) {
    var ref;
    return {
        alignSelf: "flex-start",
        fontFamily: props === null || props === void 0 ? void 0 : (ref = props.theme) === null || ref === void 0 ? void 0 : ref.font,
        fontSize: 14,
        color: "#707070",
        lineHeight: 1.3
    };
});
var DtrpContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eazuhm84"
})((0,src_define_property/* default */.Z)({
    width: 384,
    padding: "0 15px"
}, searchBarStyles_mq[0], {
    width: "100%",
    margin: 0,
    padding: "0"
}));

;// CONCATENATED MODULE: ./components/SearchBar/SearchBar.tsx





















var dividerStyles = {
    h: {
        base: "16px",
        lg: "64px"
    },
    borderColor: {
        base: "transparent",
        lg: "gray.400"
    }
};
var autocompleteService = {
    current: null
};
var SearchBar = function(param) {
    var handleSetItems = param.handleSetItems, showMobileSearch = param.showMobileSearch, setShowMobileSearch = param.setShowMobileSearch;
    var ref, ref1;
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "search"
    ]).t;
    var tz = moment_timezone.tz.guess();
    var numberOfWeeks = (0,useWeekCalculator/* useWeekCalculator */.X)().numberOfWeeks;
    var calculateWeeksToDaysDate = (0,useWeekCalculator/* useCalculateWeeksToDays */.f)().calculateWeeksToDaysDate;
    var ref2 = (0,react.useContext)(lib_context/* ItemsContext */.ct), searchInfo = ref2.searchInfo, updateDetailView = ref2.updateDetailView, updateMapLocation = ref2.updateMapLocation, updateSearchInfo = ref2.updateSearchInfo, updateUserLocation = ref2.updateUserLocation, userLocation = ref2.userLocation;
    var ref3 = (0,hooks/* useOrganizationContext */.mP)(), _context = ref3.context, tmp = _context.org, organization = (tmp === void 0 ? {} : tmp).organization;
    var methods = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            pickupDate: searchInfo === null || searchInfo === void 0 ? void 0 : searchInfo.start.local(),
            dropoffDate: searchInfo === null || searchInfo === void 0 ? void 0 : searchInfo.end.local(),
            pickupTime: searchInfo === null || searchInfo === void 0 ? void 0 : searchInfo.start.local().hour(),
            dropoffTime: searchInfo === null || searchInfo === void 0 ? void 0 : searchInfo.end.local().hour()
        }
    });
    var control = methods.control, setValue = methods.setValue, getValues = methods.getValues, watch = methods.watch;
    var formPickup = watch("pickupDate");
    var formDropoff = watch("dropoffDate");
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,chakra_ui_media_query_esm/* useMediaQuery */.ac)([
        "(max-width: 30em)"
    ]), 1), isSmallerThan30em = ref4[0];
    var isMontlyReservationEnabled = (0,hooks/* useGetOrgEligibleForMonthReservations */.m7)((0,src_object_spread/* default */.Z)({}, organization === null || organization === void 0 ? void 0 : organization["ach-enabled"], organization === null || organization === void 0 ? void 0 : organization["organization-settings"]));
    var isMobile = (0,hooks/* useResize */.aB)().isMobile;
    var type = searchInfo === null || searchInfo === void 0 ? void 0 : searchInfo.type;
    var ref5 = (0,react.useState)(userLocation), location = ref5[0], setLocation = ref5[1];
    var ref6 = (0,react.useState)(null), fail = ref6[0];
    (0,react.useEffect)(function() {
        if (!autocompleteService.current && window.google) {
            // @ts-ignore
            autocompleteService.current = new window.google.maps.places.AutocompleteService();
            // @ts-ignore
            autocompleteService.geocoder = new window.google.maps.Geocoder();
        }
    }, []);
    (0,react.useEffect)(function() {
        setLocation(userLocation);
    }, [
        userLocation
    ]);
    var onSubmit = function(data) {
        var pickupDate = data.pickupDate, pickupTime = data.pickupTime, dropoffDate = data.dropoffDate, dropoffTime = data.dropoffTime;
        // switching locations, reset fleet numbers
        if ((location === null || location === void 0 ? void 0 : location.address) !== (userLocation === null || userLocation === void 0 ? void 0 : userLocation.address)) {
            searchInfo.fleetNumbers = null;
        }
        var _start = pickupDate.hour(pickupTime).startOf("h");
        var _end = dropoffDate ? dropoffDate.hour(dropoffTime).startOf("h") : _start.clone().add(1, "d");
        updateSearchInfo((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, searchInfo), {
            start: _start,
            end: _end,
            type: type
        }));
        amplitude/* ampli.webSearch */.iN.webSearch({
            vehicleType: type || "all",
            location: location === null || location === void 0 ? void 0 : location.address,
            pickUp: moment_default()(pickupDate).format("YYYY-MM-DD HH:mm:ss"),
            dropOff: moment_default()(dropoffDate).format("YYYY-MM-DD HH:mm:ss")
        });
        updateDetailView({
            type: "",
            detailViewId: null
        });
        if (isMobile && showMobileSearch) {
            setShowMobileSearch(false);
        }
        if ((location === null || location === void 0 ? void 0 : location.lat) !== (userLocation === null || userLocation === void 0 ? void 0 : userLocation.lat) && (location === null || location === void 0 ? void 0 : location.lng) !== (userLocation === null || userLocation === void 0 ? void 0 : userLocation.lng)) {
            updateMapLocation(location);
            updateUserLocation(location);
            return;
        }
        handleSetItems();
    };
    (0,react.useEffect)(function() {
        if (!numberOfWeeks) return;
        var ref = (0,_sliced_to_array/* default */.Z)(getValues([
            "pickupDate",
            "pickupTime"
        ]), 2), pickupDate = ref[0], pickupTime = ref[1];
        var date = calculateWeeksToDaysDate(pickupDate === null || pickupDate === void 0 ? void 0 : pickupDate.clone().set("h", pickupTime).startOf("h"));
        setValue("dropoffDate", moment_default()(date), {
            shouldValidate: true
        });
        setValue("dropoffTime", pickupTime);
    }, [
        numberOfWeeks,
        calculateWeeksToDaysDate
    ]);
    var dtrpMaxHours = (0,react.useMemo)(function() {
        var ref, ref1;
        var purchaseOrderEnabled = organization === null || organization === void 0 ? void 0 : (ref = organization["organization-settings"]) === null || ref === void 0 ? void 0 : ref["book-with-purchase-order"];
        var achEnabled = organization === null || organization === void 0 ? void 0 : organization["ach-enabled"];
        var paygEnabled = organization === null || organization === void 0 ? void 0 : (ref1 = organization["organization-settings"]) === null || ref1 === void 0 ? void 0 : ref1["credit-card-payg-enabled"];
        if (purchaseOrderEnabled || achEnabled || paygEnabled) return 8760;
        return 720;
    }, [
        organization === null || organization === void 0 ? void 0 : (ref = organization["organization-settings"]) === null || ref === void 0 ? void 0 : ref["book-with-purchase-order"],
        organization === null || organization === void 0 ? void 0 : organization["ach-enabled"],
        organization === null || organization === void 0 ? void 0 : (ref1 = organization["organization-settings"]) === null || ref1 === void 0 ? void 0 : ref1["credit-card-payg-enabled"], 
    ]);
    var handleSetTimes = function() {
        var ref = (0,_sliced_to_array/* default */.Z)(getValues([
            "pickupDate",
            "pickupTime",
            "dropoffDate",
            "dropoffTime", 
        ]), 4), pickupDate = ref[0], pickupTime = ref[1], dropoffDate = ref[2], dropoffTime = ref[3];
        updateSearchInfo((0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, searchInfo), {
            start: pickupDate.clone().set("h", pickupTime).startOf("hour"),
            end: dropoffDate.clone().set("h", dropoffTime).startOf("hour")
        }));
    };
    (0,react.useEffect)(function() {
        if (!formDropoff || !formPickup) return;
        handleSetTimes();
    }, [
        formPickup,
        formDropoff
    ]);
    var didMountRef = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        if (didMountRef.current) {
            onSubmit(watch());
        } else {
            didMountRef.current = true;
        }
    }, [
        organization === null || organization === void 0 ? void 0 : organization.id
    ]);
    var formStyles = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, searchFormStyles), {
        display: {
            base: showMobileSearch ? "block" : "none",
            lg: "flex"
        },
        padding: "12px"
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, methods), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* Form */.l0, {
            sx: formStyles,
            onSubmit: methods.handleSubmit(onSubmit),
            children: [
                fail && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Alert/* default */.Z, {
                    severity: "error",
                    children: fail
                }),
                isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Divider */.iz, {
                    orientation: "horizontal",
                    sx: (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, dividerStyles), {
                        borderColor: "gray.400",
                        marginBottom: "8",
                        marginLeft: "-20px",
                        width: "calc(100% + 40px)"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LocationContainer, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LocationLabel, {
                            children: t("search:location")
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LocationAutocomplete/* LocationAutocomplete */.W, {
                            setLocationAddress: setLocation,
                            location: location,
                            testId: "input-location"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Divider */.iz, {
                    orientation: "vertical",
                    sx: dividerStyles
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_system_esm/* chakra.div */.m$.div, {
                    sx: {
                        width: [
                            "100%",
                            "100%",
                            "490px"
                        ],
                        display: "flex",
                        pos: "relative"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DtrpContainer, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* DTRPController */.Ek, {
                                displayTime: true,
                                maxHours: dtrpMaxHours,
                                control: control,
                                labels: {
                                    start: t("common:pickup"),
                                    end: t("common:dropOff")
                                },
                                names: {
                                    startDate: "pickupDate",
                                    startTime: "pickupTime",
                                    endDate: "dropoffDate",
                                    endTime: "dropoffTime"
                                }
                            })
                        }),
                        isMontlyReservationEnabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_system_esm/* chakra.span */.m$.span, {
                            sx: {
                                h: "10px",
                                mt: "7px",
                                display: "block",
                                width: isSmallerThan30em ? "100%" : "auto",
                                zIndex: "popover"
                            },
                            position: [
                                "absolute",
                                "absolute",
                                "initial"
                            ],
                            top: [
                                "0",
                                "68px"
                            ],
                            left: [
                                "0",
                                "59px"
                            ],
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WeekCalculator/* WeekTextWrapper */.J, {
                                options: {
                                    offset: [
                                        0,
                                        42
                                    ]
                                },
                                originalDate: formPickup,
                                timezone: tz
                            })
                        })
                    ]
                }),
                isMobile ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Button */.zx, {
                    width: "100%",
                    leftIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Search/* SearchIcon */.W, {}),
                    type: "submit",
                    mt: 8,
                    disabled: !formPickup || !formDropoff,
                    className: "search-execute",
                    "data-test-id": "button-search",
                    children: t("common:button.search")
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* IconButton */.hU, {
                    icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Search/* SearchIcon */.W, {}),
                    borderRadius: "full",
                    type: "submit",
                    disabled: !formPickup || !formDropoff,
                    mt: 4,
                    className: "search-execute",
                    "data-test-id": "button-search",
                    "aria-label": "search"
                })
            ]
        })
    }));
};
/* harmony default export */ var SearchBar_SearchBar = (SearchBar);

;// CONCATENATED MODULE: ./components/SearchBar/index.ts


// EXTERNAL MODULE: ./components/SearchTab/index.ts + 1 modules
var SearchTab = __webpack_require__(41241);
;// CONCATENATED MODULE: ./components/SearchBar/MobileSearchBar.tsx










var MobileSearchBar = function(param) {
    var handleSetItems = param.handleSetItems, showMobileSearch = param.showMobileSearch, setShowMobileSearch = param.setShowMobileSearch;
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "search"
    ]).t;
    var ref = (0,next_router.useRouter)(), isMobileAndSpecificSearchOpen = ref.query.isMobileAndSpecificSearchOpen;
    var defaultIndex = Number(!!isMobileAndSpecificSearchOpen);
    var user = js_cookie_default().get("user") || "";
    return showMobileSearch ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* Grid */.rj, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* Box */.xu, {
                onClick: function() {
                    return setShowMobileSearch(false);
                },
                display: "flex",
                justifyContent: "flex-end",
                m: "4",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* MidText */.Jc, {
                        children: t("common:button.close")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Close/* CloseIcon */.T, {
                        "data-test-id": "close-button",
                        color: "cheese",
                        w: "6",
                        h: "6"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Divider */.iz, {
                sx: {
                    margin: "0 16px",
                    width: "initial",
                    color: "gray.400"
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_tabs_esm/* Tabs */.mQ, {
                defaultIndex: defaultIndex,
                "aria-label": "search-mobile-tabs",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_tabs_esm/* TabList */.td, {
                        justifyContent: "center",
                        mt: 4,
                        height: "auto",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_tabs_esm/* Tab */.OK, {
                                sx: SearchTab/* tabStyles */.u,
                                children: t("search:searchAll.tabs.searchAll")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchTab/* SearchTab */.y, {
                                isDisabled: !user
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_tabs_esm/* TabPanels */.nP, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_tabs_esm/* TabPanel */.x4, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchBar_SearchBar, {
                                    handleSetItems: handleSetItems,
                                    showMobileSearch: showMobileSearch,
                                    setShowMobileSearch: setShowMobileSearch
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_tabs_esm/* TabPanel */.x4, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_components/* FlexCol */.Ht, {
                                    p: 3,
                                    children: [
                                        t("search:searchAll.tabs.searchByFleet"),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemSearchSelect/* ItemSearchSelect */.g, {})
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchBar_SearchBar, {
        handleSetItems: handleSetItems,
        showMobileSearch: showMobileSearch,
        setShowMobileSearch: setShowMobileSearch
    });
};

// EXTERNAL MODULE: ./features/search/weekCalculator/index.tsx
var weekCalculator = __webpack_require__(81123);
;// CONCATENATED MODULE: ./components/ItemFilter/styles.js




var ItemFilter_styles_mqMax = (0,helpers/* generateMQ */.Nt)("max");
var styles_FilterContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eop8umj0"
})(function(props) {
    var ref, ref1;
    return (0,src_define_property/* default */.Z)({
        height: "100%",
        borderTop: "1px solid ".concat(props === null || props === void 0 ? void 0 : (ref = props.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.gray[400]),
        width: "100%",
        overflow: "auto"
    }, ItemFilter_styles_mqMax[0], {
        borderTop: "none"
    });
});
var InnerContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eop8umj1"
})({
    margin: "0 16px"
});
var FilterHeader = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eop8umj2"
})({
    display: "flex",
    justifyContent: "flex-end"
});
var CloseContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eop8umj3"
})({
    alignItems: "center",
    cursor: "pointer",
    display: "flex",
    margin: "16px 24px 16px 0"
});
var BookingContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eop8umj4"
})(function(props) {
    var ref, ref1;
    return (0,src_define_property/* default */.Z)({
        borderTop: "1px solid ".concat(props === null || props === void 0 ? void 0 : (ref = props.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.gray[400]),
        margin: "0 24px 32px 0"
    }, ItemFilter_styles_mqMax[0], {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        margin: "0 0 32px 0"
    });
});
var MobileBookingContainerWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eop8umj5"
})({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
});
var MobileBookingContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eop8umj6"
})((0,src_define_property/* default */.Z)({}, ItemFilter_styles_mqMax[0], {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column"
}));
var HeaderContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eop8umj7"
})({
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    marginTop: 24
});
var InstantContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eop8umj8"
})((0,src_define_property/* default */.Z)({
    alignItems: "center",
    display: "flex"
}, ItemFilter_styles_mqMax[0], {
    marginBottom: 8
}));
var ClearApplyContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eop8umj9"
})((0,src_define_property/* default */.Z)({
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: "24px"
}, ItemFilter_styles_mqMax[0], {
    display: "none"
}));
var BodyContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eop8umj10"
})({
    display: "flex",
    maxWidth: 240
});
var ListingsContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eop8umj11"
})({
    alignItems: "center",
    display: "flex",
    justifyContent: "flex-start",
    marginTop: 15
});
var PriceContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eop8umj12"
})((0,src_define_property/* default */.Z)({
    display: "flex",
    justifyContent: "flex-start",
    marginBottom: 24
}, ItemFilter_styles_mqMax[0], {
    justifyContent: "center",
    marginTop: 32
}));
var ListingsHeader = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(base_components/* Header */.h4, {
    target: "eop8umj13"
})({
    fontWeight: "normal"
});
var MobileButtonContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eop8umj14"
})((0,src_define_property/* default */.Z)({
    display: "none"
}, ItemFilter_styles_mqMax[0], {
    boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.1), 0px -2px 8px rgba(0, 0, 0, 0.1)",
    display: "flex",
    backgroundColor: "white",
    width: "100%",
    flexDirection: "column",
    padding: "16px"
}));

;// CONCATENATED MODULE: ./components/ItemFilter/index.jsx










var ItemFilter = function(param) {
    var setShowFilter = param.setShowFilter;
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "ev",
        "search"
    ]).t;
    var ref = (0,react.useContext)(lib_context/* ItemsContext */.ct), applyInfo = ref.applyInfo, searchInfo = ref.searchInfo, updateApplyInfo = ref.updateApplyInfo, updateSearchInfo = ref.updateSearchInfo;
    var ref1 = (0,react.useState)((applyInfo === null || applyInfo === void 0 ? void 0 : applyInfo.isInstantBook) || false), showListings = ref1[0], setShowListings = ref1[1];
    var ref2 = (0,react.useState)((applyInfo === null || applyInfo === void 0 ? void 0 : applyInfo.showEV) || false), showEVs = ref2[0], setShowEVs = ref2[1];
    var handleClear = function() {
        setShowListings(false);
        setShowEVs(false);
    };
    var handleApply = function() {
        updateApplyInfo({
            isInstantBook: showListings,
            showEV: showEVs
        });
        updateSearchInfo((0,src_object_spread/* default */.Z)({}, searchInfo));
        setShowFilter(false);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(styles_FilterContainer, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InnerContainer, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FilterHeader, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CloseContainer, {
                            onClick: function() {
                                return setShowFilter(false);
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* SubHeader */.bU, {
                                    size: 14,
                                    children: t("button.close")
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Close/* CloseIcon */.T, {
                                    "data-test-id": "close-button",
                                    color: "cheese",
                                    w: "6",
                                    h: "6"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BookingContainer, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ClearApplyContainer, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Button */.zx, {
                                        variant: "outline",
                                        size: "md",
                                        mr: 2,
                                        width: "120px",
                                        onClick: handleClear,
                                        children: t("button.clear")
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Button */.zx, {
                                        size: "md",
                                        className: "search-filter-applied",
                                        width: "120px",
                                        "data-test-id": "button-apply-filter",
                                        onClick: handleApply,
                                        children: t("button.apply")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MobileBookingContainerWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MobileBookingContainer, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderContainer, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InstantContainer, {
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Header */.h4, {
                                                            size: 18,
                                                            children: t("ev:ev")
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EVBadge/* EVBadgeIcon */.T, {
                                                            ml: 2
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BodyContainer, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Body */.uT, {
                                                    size: 14,
                                                    color: "gray",
                                                    style: {
                                                        lineHeight: "18px"
                                                    },
                                                    children: t("search:filters.evSlug")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ListingsContainer, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Checkbox */.XZ, {
                                                        isChecked: showEVs,
                                                        margin: 1,
                                                        size: "lg",
                                                        onChange: function() {
                                                            return setShowEVs(!showEVs);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListingsHeader, {
                                                        size: 14,
                                                        children: t("search:filters.onlyEv")
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MobileBookingContainer, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderContainer, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InstantContainer, {
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Header */.h4, {
                                                            size: 18,
                                                            children: t("instantBook")
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InstantBook/* InstantBookIcon */.n, {
                                                            color: "cheese",
                                                            ml: 2
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BodyContainer, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Body */.uT, {
                                                    size: 14,
                                                    color: "gray",
                                                    style: {
                                                        lineHeight: "18px"
                                                    },
                                                    children: t("search:filters.instaSlug")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ListingsContainer, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Checkbox */.XZ, {
                                                        "data-test-id": "filter-only-instant",
                                                        isChecked: showListings,
                                                        size: "lg",
                                                        margin: 1,
                                                        onChange: function() {
                                                            return setShowListings(!showListings);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListingsHeader, {
                                                        size: 14,
                                                        children: t("search:filters.onlyInsta")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MobileButtonContainer, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Button */.zx, {
                        isFullWidth: true,
                        display: {
                            base: "block",
                            lg: "none"
                        },
                        size: "md",
                        variant: "outline",
                        onClick: handleClear,
                        children: "Clear"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Button */.zx, {
                        isFullWidth: true,
                        size: "md",
                        mt: 6,
                        display: {
                            base: "block",
                            lg: "none"
                        },
                        className: "search-filter-applied",
                        onClick: handleApply,
                        children: t("button.apply")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_ItemFilter = (ItemFilter);
ItemFilter.propTypes = {
    setShowFilter: (prop_types_default()).func
};

// EXTERNAL MODULE: ./components/LeftNavMenu/index.ts + 1 modules
var LeftNavMenu = __webpack_require__(30802);
;// CONCATENATED MODULE: ./components/Search/searchStyles.js


var ItemList = (0,chakra_ui_system_esm/* chakra */.m$)(base_components/* FlexCol */.Ht, {
    baseStyle: {
        overflow: "scroll",
        height: "100%",
        width: {
            base: "100%",
            lg: "auto"
        }
    },
    label: "ItemList"
});
var searchStyles_MapContainer = (0,chakra_ui_system_esm/* chakra */.m$)(base_components/* Box */.xu, {
    baseStyle: {
        height: "100%",
        boxShadow: "inset",
        overflow: "hidden",
        width: {
            base: "100%",
            lg: "auto"
        }
    },
    label: "MapContainer"
});
var UpdateContainer = (0,chakra_ui_system_esm/* chakra */.m$)(base_components/* FlexRow */.gq, {
    baseStyle: {
        display: {
            base: "flex",
            lg: "none"
        },
        alignItems: "center",
        justifyContent: "center",
        borderBottom: "1px",
        borderColor: "gray.400",
        py: 3
    },
    label: "UpdateContainer"
});
var DeliveryUpdateContainer = (0,chakra_ui_system_esm/* chakra */.m$)(base_components/* FlexRow */.gq, {
    baseStyle: {
        display: {
            base: "flex",
            lg: "none"
        },
        alignItems: "center",
        borderBottom: "1px",
        borderColor: "gray.400",
        py: 3,
        width: "100%"
    },
    label: "DeliveryUpdateContainer"
});
var searchStyles_DeliveryContainer = (0,chakra_ui_system_esm/* chakra */.m$)(base_components/* FlexRow */.gq, {
    baseStyle: {
        marginRight: 16
    },
    label: "DeliveryContainer"
});
var FilterButton = (0,chakra_ui_system_esm/* chakra */.m$)(base_components/* Button */.zx, {
    baseStyle: {
        mt: {
            base: 0,
            lg: 4
        },
        mx: {
            base: 4,
            lg: 4
        }
    },
    label: "FilterButton"
});
var DrawerHeaderSx = {
    pt: 10,
    pl: 10,
    fontSize: "3xl",
    fontWeight: "bold"
};

;// CONCATENATED MODULE: ./components/Search/Search.tsx
























var topNav = theme/* heights.topNav */.Db.topNav, Search_searchBar = theme/* heights.searchBar */.Db.searchBar, Search_cartBar = theme/* heights.cartBar */.Db.cartBar;
var leftNavOpen = theme/* widths.leftNavOpen */.Q0.leftNavOpen, leftNavClosed = theme/* widths.leftNavClosed */.Q0.leftNavClosed, searchDrawer = theme/* widths.searchDrawer */.Q0.searchDrawer, searchItem = theme/* widths.searchItem */.Q0.searchItem, searchItemDefault = theme/* widths.searchItemDefault */.Q0.searchItemDefault;
var Search_Search = function() {
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var mobileSearchOpen = (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.isMobileAndSpecificSearchOpen) === "true" || false;
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "search"
    ]).t;
    var ref2 = (0,hooks/* useResize */.aB)(), isMobile = ref2.isMobile, isDesktop = ref2.isDesktop;
    var ref3 = (0,react.useState)(false), showMobileMap = ref3[0], setShowMobileMap = ref3[1];
    var drawerSize = isDesktop ? "lg" : "full";
    var isCollapsed = (0,LeftNavMenu/* useLeftNavMenuContext */.RG)().isCollapsed;
    var gridRef = react.useRef(null);
    var ref4 = (0,react.useContext)(lib_context/* ItemsContext */.ct), detailView = ref4.detailView, updateDetailView = ref4.updateDetailView, updateSelectedItem = ref4.updateSelectedItem, isLoading = ref4.isLoading, setIsInitialSearch = ref4.setIsInitialSearch;
    var ref5 = (0,react.useState)(mobileSearchOpen), showMobileSearch = ref5[0], setShowMobileSearch = ref5[1];
    var user = (0,hooks/* useUser */.aF)().user;
    var cart = (0,react.useContext)(lib_context/* CartContext */.A9).cart;
    var updateEstimate = (0,lib_context/* useReservationEstimate */.Qf)().updateEstimate;
    var type = detailView.type, detailViewId = detailView.detailViewId, isAvailable = detailView.isAvailable;
    var showItemDetail = Boolean(detailViewId && type === "item");
    var showReservation = Boolean(detailViewId && type === "reservation");
    // Note: calculate the postioning of the drawers with user or leftnav
    var searchItemWidth = user ? searchItem : searchItemDefault;
    var closed = leftNavClosed + searchItemWidth;
    var open = leftNavOpen + searchItemWidth;
    var leftPosition = isCollapsed ? "".concat(closed, "px !important") : "".concat(open, "px !important");
    var drawerContent = {
        top: {
            base: 0,
            lg: "".concat(topNav + Search_searchBar, "px !important")
        },
        left: {
            base: "0 !important",
            lg: user ? leftPosition : "".concat(searchItemWidth, "px !important")
        },
        boxShadow: "base",
        width: {
            base: "100% !important",
            lg: "".concat(searchDrawer, "px !important")
        }
    };
    var onDrawerClose = function() {
        updateSelectedItem(0);
        updateEstimate({
            "item-id": 0
        });
        updateDetailView({
            type: "",
            detailViewId: null
        });
    };
    var ref6 = (0,react.useState)(false), showFilter = ref6[0], setShowFilter = ref6[1];
    var handleFilterClick = function() {
        setShowFilter(true);
        updateDetailView({
            type: "",
            detailViewId: null
        });
    };
    var data = (0,hooks/* useSanctuary */.TQ)().data;
    var maintenanceWindow = data === null || data === void 0 ? void 0 : (ref1 = data.config) === null || ref1 === void 0 ? void 0 : ref1.maintenanceWindow;
    var details = (maintenanceWindow === null || maintenanceWindow === void 0 ? void 0 : maintenanceWindow.details) || "";
    var startAt = (maintenanceWindow === null || maintenanceWindow === void 0 ? void 0 : maintenanceWindow.startAt) || "";
    var endAt = (maintenanceWindow === null || maintenanceWindow === void 0 ? void 0 : maintenanceWindow.endAt) || "";
    var status = (maintenanceWindow === null || maintenanceWindow === void 0 ? void 0 : maintenanceWindow.status) || "";
    var hasMaintenanceData = !!(Object.keys(maintenanceWindow || {}).length > 0);
    var timezone = moment_timezone_default().tz.guess();
    var startDate = moment_timezone_default()(startAt).format("M/D");
    var startTime = moment_timezone_default()(startAt).tz(timezone).format("h:mm A z");
    var endDate = moment_timezone_default()(endAt).format("M/D");
    var endTime = moment_timezone_default()(endAt).tz(timezone).format("h:mm A z");
    var startString = "".concat(startDate, " ").concat(t("common:at"), " ").concat(startTime);
    var endString = "".concat(endDate, " ").concat(t("common:at"), " ").concat(endTime);
    if (status === "active" && router.pathname !== "/outage") {
        router.replace({
            pathname: "/outage",
            query: {
                details: details,
                endString: endString
            }
        });
    }
    // code below fixes "flash" infinite loop between search/outage pages when user tried to go back from outage page during an outage
    (0,react.useEffect)(function() {
        var handlePopState = function(param) {
            var url = param.url;
            if (url.includes("/outage")) {
                return false;
            }
            return true;
        };
        if (status === "active") {
            router.beforePopState(handlePopState);
        }
        return function() {
            router.beforePopState(function() {
                return true;
            });
        };
    }, [
        router,
        status
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
        ref: gridRef,
        "data-test-id": "search-container-grid",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(weekCalculator/* WeeklyCalculatorProvider */.W, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileSearchBar, {
                    handleSetItems: function() {
                        return setIsInitialSearch(false);
                    },
                    showMobileSearch: showMobileSearch,
                    setShowMobileSearch: setShowMobileSearch
                })
            }),
            hasMaintenanceData && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MaintenanceBanner, {
                details: details,
                startAt: startString,
                endAt: endString,
                status: status
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClickAwayListener/* default */.Z, {
                onClickAway: function() {
                    return updateSelectedItem(0);
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
                    direction: showMobileMap ? "column" : "row",
                    "data-test-id": "list-map-container-grid",
                    display: showMobileSearch ? "none" : "flex",
                    minHeight: "100%",
                    height: {
                        base: "100%",
                        lg: cart ? "calc(100vh - ".concat(topNav + Search_searchBar + Search_cartBar, "px)") : "100%"
                    },
                    children: [
                        !showFilter && !showMobileSearch && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
                            direction: showMobileMap ? "row" : "column",
                            overflow: "scroll",
                            width: {
                                base: "100%",
                                lg: "544px"
                            },
                            children: [
                                isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
                                    width: "100%",
                                    display: {
                                        base: "flex",
                                        lg: "none"
                                    },
                                    alignItems: "center",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                    borderBottom: "1px",
                                    borderColor: "gray.400",
                                    py: "3",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_button_esm/* IconButton */.hU, {
                                            "data-test-id": "filter-search",
                                            icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Filter/* FilterIcon */.k, {
                                                h: 5,
                                                w: 5
                                            }),
                                            variant: "outline",
                                            sx: {
                                                "> span": {
                                                    marginInlineEnd: {
                                                        base: 0,
                                                        lg: ".5rem"
                                                    }
                                                }
                                            },
                                            w: {
                                                base: 10,
                                                md: "auto"
                                            },
                                            onClick: handleFilterClick,
                                            "aria-label": "filter search"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FilterButton, {
                                            leftIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Search/* SearchIcon */.W, {}),
                                            "data-test-id": "filter-button",
                                            variant: "outline",
                                            size: "md",
                                            onClick: function() {
                                                return setShowMobileSearch(true);
                                            },
                                            "aria-label": "search",
                                            children: t("common:button.searchForVehicles")
                                        }),
                                        !showMobileMap && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_button_esm/* IconButton */.hU, {
                                            "data-test-id": "filter-map",
                                            icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Map/* MapIcon */.Z, {
                                                h: 5,
                                                w: 5
                                            }),
                                            variant: "outline",
                                            "aria-label": "show map",
                                            w: 10,
                                            onClick: function() {
                                                return setShowMobileMap(true);
                                            }
                                        }),
                                        showMobileMap && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_button_esm/* IconButton */.hU, {
                                            "data-test-id": "search-item-view",
                                            icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List/* ListIcon */.D, {
                                                h: 5,
                                                w: 5
                                            }),
                                            variant: "outline",
                                            "aria-label": "show list",
                                            w: 10,
                                            onClick: function() {
                                                return setShowMobileMap(false);
                                            }
                                        })
                                    ]
                                }),
                                !showMobileMap && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_ItemContainer, {
                                    isLoading: isLoading,
                                    showFilter: showFilter,
                                    handleFilterClick: handleFilterClick
                                })
                            ]
                        }),
                        showFilter && !isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Flex */.kC, {
                            flexDirection: "column",
                            width: {
                                base: "100%",
                                lg: "544px"
                            },
                            "data-test-id": "filter-container",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_ItemFilter, {
                                setShowFilter: setShowFilter
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* Drawer */.dy, {
                            closeOnEsc: true,
                            blockScrollOnMount: !isDesktop,
                            isOpen: showItemDetail,
                            placement: "bottom",
                            size: drawerSize,
                            portalProps: {
                                containerRef: gridRef
                            },
                            onClose: onDrawerClose,
                            trapFocus: false,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_modal_esm/* DrawerContent */.sc, {
                                sx: drawerContent,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* DrawerHeader */.OX, {
                                        sx: DrawerHeaderSx,
                                        children: t("search:detail.title")
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DrawerCloseButton, {
                                        top: 10,
                                        right: 10
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* DrawerBody */.Ng, {
                                        children: showItemDetail && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Item_ItemDetail, {
                                            updateDetailView: updateDetailView,
                                            id: detailViewId,
                                            isAvailable: Boolean(isAvailable)
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* Drawer */.dy, {
                            closeOnEsc: true,
                            blockScrollOnMount: false,
                            isOpen: showReservation,
                            placement: "bottom",
                            portalProps: {
                                containerRef: gridRef
                            },
                            size: drawerSize,
                            onClose: onDrawerClose,
                            trapFocus: false,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_modal_esm/* DrawerContent */.sc, {
                                "data-test-id": "search-summary-drawer",
                                sx: drawerContent,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* DrawerHeader */.OX, {
                                        sx: DrawerHeaderSx,
                                        children: t("search:summary.title")
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DrawerCloseButton, {
                                        top: 10,
                                        right: 10,
                                        onClick: function() {
                                            return amplitude/* ampli.closeReservationSummary */.iN.closeReservationSummary();
                                        }
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_modal_esm/* DrawerBody */.Ng, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchSummary_SearchSummary, {})
                                    })
                                ]
                            })
                        }),
                        (isDesktop || showMobileMap) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Flex */.kC, {
                            flexDirection: showMobileMap ? "row" : "column",
                            height: "100%",
                            boxShadow: "inset",
                            overflow: "hidden",
                            width: {
                                base: "100%",
                                lg: "auto"
                            },
                            flex: "1",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_ItemMap, {
                                isLoading: isLoading
                            })
                        })
                    ]
                })
            }),
            cart && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_ItemCart, {})
        ]
    });
};
/* harmony default export */ var components_Search_Search = (Search_Search);

;// CONCATENATED MODULE: ./components/Search/index.ts


;// CONCATENATED MODULE: ./hooks/use-items/types.ts
var SortDirection;
(function(SortDirection) {
    SortDirection["ASC"] = "asc";
    SortDirection["DESC"] = "desc";
})(SortDirection || (SortDirection = {}));

// EXTERNAL MODULE: ./hooks/use-sanctuary.ts
var use_sanctuary = __webpack_require__(90228);
;// CONCATENATED MODULE: ./components/SearchPage/SearchPage.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 


















var SearchPage = function() {
    var ref, ref1;
    var ref2 = (0,hooks/* useSanctuary */.TQ)(), sanctuaryData = ref2.data;
    var minBookingDays = (sanctuaryData === null || sanctuaryData === void 0 ? void 0 : (ref = sanctuaryData.config) === null || ref === void 0 ? void 0 : ref.minimumBookingDuration) || use_sanctuary/* FALLBACK_MIN_BOOKING_DAYS */.t;
    var defaultStart = moment_default()().startOf("hour").add(2, "hour");
    var defaultEnd = moment_default()().startOf("hour").add(2, "hour").add(minBookingDays, "days");
    var ref3 = (0,hooks/* useOrganizationContext */.mP)(), org = ref3.context.org;
    var updateEstimate = (0,lib_context/* useReservationEstimate */.Qf)().updateEstimate;
    var orgId = org === null || org === void 0 ? void 0 : (ref1 = org.organization) === null || ref1 === void 0 ? void 0 : ref1.id;
    var router = (0,next_router.useRouter)();
    var query = router.query;
    // honor query params if present on initial load
    var ref4 = (0,react.useState)(Object.keys(query).length === 0), isInitialSearch = ref4[0], setIsInitialSearch = ref4[1];
    var typeQuery = query === null || query === void 0 ? void 0 : query.type;
    var ref5 = (0,hooks/* useGoogleMapsApi */.Bk)(), isGoogleLoaded = ref5.isGoogleLoaded, googleMapsLoadError = ref5.googleMapsLoadError;
    var geocoder = (0,useGoogleLocationServices/* useGoogleLocationServices */.u)().geocoder;
    var dispatch = (0,hooks/* useGoogleMaps */.j9)().dispatch;
    var startQuery = (query === null || query === void 0 ? void 0 : query.start) ? moment_default()(decodeURIComponent(query === null || query === void 0 ? void 0 : query.start)) : moment_default()(new Date().toString());
    var endQuery = (query === null || query === void 0 ? void 0 : query.end) ? moment_default()(decodeURIComponent(query === null || query === void 0 ? void 0 : query.end)) : moment_default()(new Date().toString());
    var locationQuery = query === null || query === void 0 ? void 0 : query.location;
    var fleetNumbersRaw = query === null || query === void 0 ? void 0 : query["fleet-numbers"];
    var isMobileAndSpecificSearchOpen = query === null || query === void 0 ? void 0 : query.isMobileAndSpecificSearchOpen;
    var ref6 = (0,react.useState)(fleetNumbersRaw ? fleetNumbersRaw.split(",") : []), fleetNumbers = ref6[0];
    var isInstantBook = (query === null || query === void 0 ? void 0 : query.instabook) ? (query === null || query === void 0 ? void 0 : query.instabook) === "true" : undefined;
    var showEV = (query === null || query === void 0 ? void 0 : query["is-electric-vehicle"]) ? (query === null || query === void 0 ? void 0 : query["is-electric-vehicle"]) === "true" : undefined;
    var starter = defaultStart.clone();
    if (startQuery && startQuery.isValid() && !startQuery.isBefore(moment_default()().add(1, "hour").startOf("hour"))) {
        starter = startQuery;
    }
    var ender = defaultEnd.clone();
    if (endQuery && endQuery.isValid() && !endQuery.isBefore(moment_default()().add(1, "hour"))) {
        ender = endQuery;
    }
    var ref7 = (0,react.useState)({
        start: starter,
        end: ender,
        type: typeQuery || ""
    }), searchInfo = ref7[0], setSearchInfo = ref7[1];
    var currenttz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var userOrServerLocation = js_cookie_default().getJSON("userLocation") || js_cookie_default().getJSON("serverLocation");
    var initialMapLocation = locationQuery ? {
        address: locationQuery
    } : userOrServerLocation;
    var ref8 = (0,react.useState)(userOrServerLocation), userLocation = ref8[0], setUserLocation = ref8[1];
    var ref9 = (0,react.useState)(initialMapLocation), mapLocation = ref9[0], setMapLocation = ref9[1];
    var ref10 = (0,react.useState)({
        sortField: "distance",
        sortDirection: SortDirection.ASC
    }), sortInfo = ref10[0], setSortInfo = ref10[1];
    // CHECK ME - we may or may not need full `mapLocation` obj.
    (0,react.useEffect)(function() {
        if ((mapLocation === null || mapLocation === void 0 ? void 0 : mapLocation.lat) && (mapLocation === null || mapLocation === void 0 ? void 0 : mapLocation.lng)) {
            var lat = mapLocation.lat, lng = mapLocation.lng;
            dispatch({
                type: map_actions/* ACTIONS.SET_LATLNG */.a.SET_LATLNG,
                payload: {
                    lat: lat,
                    lng: lng
                }
            });
        }
    }, [
        mapLocation === null || mapLocation === void 0 ? void 0 : mapLocation.lat,
        mapLocation === null || mapLocation === void 0 ? void 0 : mapLocation.lng,
        dispatch
    ]);
    var ref11 = (0,react.useState)(0), selectedItem = ref11[0], setSelectedItem = ref11[1];
    // NOTE: updates Search Views - vehicle detail, reservation
    var ref12 = (0,react.useState)({
        detailViewId: null,
        type: ""
    }), detailView = ref12[0], setDetailView = ref12[1];
    var ref13 = (0,react.useState)({
        isInstantBook: isInstantBook,
        showEV: showEV
    }), applyInfo = ref13[0], setApplyInfo = ref13[1];
    var ref14 = (0,react.useState)(false), locationBlocked = ref14[0], setLocationBlocked = ref14[1];
    var handleUrl = function(param) {
        var searchOptions = param.searchOptions, mapLocationOptions = param.mapLocationOptions, filterOptions = param.filterOptions;
        var urlParams = [];
        var start = searchOptions === null || searchOptions === void 0 ? void 0 : searchOptions.start;
        var end = searchOptions === null || searchOptions === void 0 ? void 0 : searchOptions.end;
        var type = searchOptions === null || searchOptions === void 0 ? void 0 : searchOptions.type;
        var instant = filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.isInstantBook;
        var electric = filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.showEV;
        var location = mapLocationOptions === null || mapLocationOptions === void 0 ? void 0 : mapLocationOptions.address;
        if (start && end) {
            var startTZ = (0,moment_timezone.tz)(start, currenttz);
            var endTz = (0,moment_timezone.tz)(end, currenttz);
            urlParams.push("start=".concat(encodeURIComponent(startTZ.format("MM/DD/YY hh:mm a z"))));
            urlParams.push("end=".concat(encodeURIComponent(endTz.format("MM/DD/YY hh:mm a z"))));
        }
        if (type) {
            urlParams.push("type=".concat(encodeURIComponent(type)));
        }
        if (location) {
            urlParams.push("location=".concat(encodeURIComponent(location)));
        }
        if (instant !== undefined) {
            urlParams.push("instabook=".concat(instant));
        }
        if (electric !== undefined) {
            urlParams.push("is-electric-vehicle=".concat(electric));
        }
        if (fleetNumbers && fleetNumbers.length > 0) {
            // if we're changing location, remove specific fleet numbers
            if ((searchInfo === null || searchInfo === void 0 ? void 0 : searchInfo.fleetNumbers) === null) {
                urlParams = urlParams.filter(function(param) {
                    return param !== "fleet-numbers";
                });
            } else {
                urlParams.push("fleet-numbers=".concat(encodeURIComponent(fleetNumbers.join(","))));
            }
        }
        if (isMobileAndSpecificSearchOpen) {
            urlParams.push("isMobileAndSpecificSearchOpen=true");
        }
        // TODO - change to use `some` so it exits on the first diff it finds
        var hasChanged = urlParams.reduce(function(acc, str) {
            var decode = decodeURIComponent(str);
            var ref = (0,_sliced_to_array/* default */.Z)(decode.split("="), 2), key = ref[0], val = ref[1];
            if (val !== router.query[key]) {
                return true;
            }
            return acc;
        }, false);
        if (hasChanged) {
            router.push("/search?".concat(urlParams.join("&")), undefined, {
                shallow: true
            });
        }
    };
    (0,react.useEffect)(function() {
        handleUrl({
            searchOptions: searchInfo,
            mapLocationOptions: mapLocation,
            filterOptions: applyInfo
        });
    }, [
        searchInfo,
        mapLocation,
        applyInfo
    ]);
    var updateSearchInfo = function(newInfo) {
        updateEstimate({
            "pick-up": newInfo.start.toISOString(),
            "drop-off": newInfo.end.toISOString()
        });
        setSearchInfo(newInfo);
    };
    var updateUserLocation = function(newLocation) {
        setUserLocation(newLocation);
    };
    var updateMapLocation = function(_param) {
        var newLocation = (0,_extends/* default */.Z)({}, _param);
        setMapLocation(newLocation);
    };
    var updateDetailView = function(viewInfo) {
        setDetailView(viewInfo);
    };
    var updateSortInfo = function(newSortInfo) {
        setSortInfo(newSortInfo);
    };
    var updateApplyInfo = function(newApplyInfo) {
        setIsInitialSearch(false);
        handleUrl({
            searchOptions: searchInfo,
            mapLocationOptions: mapLocation,
            filterOptions: newApplyInfo
        });
        setApplyInfo(newApplyInfo);
    };
    var updateLocationBlocked = function(newPreference) {
        setLocationBlocked(newPreference);
    };
    var updateSelectedItem = function(id) {
        if (!!id) {
            updateEstimate({
                "item-id": id
            });
        }
        setSelectedItem(id);
    };
    var geocode = function(param) {
        var lat = param.lat, lng = param.lng, _address = param.address, address = _address === void 0 ? "" : _address;
        var input = (0,src_object_spread/* default */.Z)({}, lat && lng ? {
            location: {
                lat: lat,
                lng: lng
            }
        } : {}, address ? {
            address: address
        } : {});
        geocoder === null || geocoder === void 0 ? void 0 : geocoder.geocode(input, function(res) {
            var ref, ref1, ref2, ref3;
            var info = res && res[0];
            var geocodeLat = info === null || info === void 0 ? void 0 : (ref = info.geometry) === null || ref === void 0 ? void 0 : (ref1 = ref.location) === null || ref1 === void 0 ? void 0 : ref1.lat();
            var geocodeLng = info === null || info === void 0 ? void 0 : (ref2 = info.geometry) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.location) === null || ref3 === void 0 ? void 0 : ref3.lng();
            var newLocation = {
                lat: geocodeLat,
                lng: geocodeLng,
                address: info === null || info === void 0 ? void 0 : info.formatted_address
            };
            updateUserLocation(newLocation);
            updateMapLocation(newLocation);
        });
    };
    // useEffect below fixes cannot update unmounted component bug
    (0,react.useEffect)(function() {
        var isMounted = true;
        if (!isGoogleLoaded || googleMapsLoadError || !geocoder) {
            return;
        }
        if (mapLocation === null || mapLocation === void 0 ? void 0 : mapLocation.address) {
            if (isMounted) {
                geocode({
                    address: mapLocation.address
                });
            }
        } else {
            (0,utils_location/* checkBrowserLocation */.ye)().then(function(pos) {
                if (isMounted) {
                    var coords = pos.coords;
                    var loc = {
                        lat: coords.latitude,
                        lng: coords.longitude,
                        address: locationQuery
                    };
                    js_cookie_default().set("userLocation", loc);
                    geocode((0,src_object_spread/* default */.Z)({}, loc));
                }
            }).catch(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                var loc;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!isMounted) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0,utils_location/* currentLocation */.DX)()
                            ];
                        case 1:
                            loc = _state.sent();
                            geocode(loc);
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            }));
            return function() {
                isMounted = false;
            };
        }
    }, [
        isGoogleLoaded,
        googleMapsLoadError,
        geocoder,
        mapLocation === null || mapLocation === void 0 ? void 0 : mapLocation.address
    ]);
    var ref15 = (0,hooks/* useItems */.Ce)({
        isInitialSearch: isInitialSearch,
        orgId: orgId,
        lat: mapLocation === null || mapLocation === void 0 ? void 0 : mapLocation.lat,
        lng: mapLocation === null || mapLocation === void 0 ? void 0 : mapLocation.lng,
        isInstantBook: isInstantBook,
        showEV: showEV,
        startTime: searchInfo.start.clone().utc().format("YYYY-MM-DD HH:mm:ss"),
        endTime: searchInfo.end.clone().utc().format("YYYY-MM-DD HH:mm:ss"),
        type: searchInfo.type,
        fleetNumbersURI: fleetNumbersRaw
    }), data = ref15.data, isLoading = ref15.isLoading;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(lib_context/* ItemsContext.Provider */.ct.Provider, {
        value: {
            setIsInitialSearch: setIsInitialSearch,
            isLoading: isLoading,
            items: data,
            searchInfo: searchInfo,
            updateSearchInfo: updateSearchInfo,
            updateSortInfo: updateSortInfo,
            sortInfo: sortInfo,
            updateApplyInfo: updateApplyInfo,
            applyInfo: applyInfo,
            updateLocationBlocked: updateLocationBlocked,
            detailView: detailView,
            updateDetailView: updateDetailView,
            locationBlocked: locationBlocked,
            fleetNumbers: fleetNumbers,
            selectedItem: selectedItem,
            updateSelectedItem: updateSelectedItem,
            updateUserLocation: updateUserLocation,
            userLocation: userLocation,
            updateMapLocation: updateMapLocation,
            mapLocation: mapLocation
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Search_Search, {})
    });
};
/* harmony default export */ var SearchPage_SearchPage = (SearchPage);


/***/ }),

/***/ 47511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ SimpleVehicleLocationMap; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _react_google_maps_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25937);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71750);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73677);






var SimpleVehicleLocationMap = function(param) {
    var center = param.center, icon = param.icon, _zoom = param.zoom, zoom = _zoom === void 0 ? 16 : _zoom;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var ref = (0,_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useGoogleMapsApi */ .Bk)(), isGoogleLoaded = ref.isGoogleLoaded, googleMapsLoadError = ref.googleMapsLoadError;
    if (googleMapsLoadError) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
            children: t("messages.genericError")
        });
    }
    if (!isGoogleLoaded) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
            children: t("messages.loadingText")
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_react_google_maps_api__WEBPACK_IMPORTED_MODULE_4__/* .GoogleMap */ .b6, {
        id: "map-simple-view",
        mapContainerStyle: {
            width: "inherit",
            height: "inherit"
        },
        options: {
            disableDefaultUI: true,
            scrollwheel: false,
            clickableIcons: false,
            fullscreenControl: false,
            zoomControl: true
        },
        zoom: zoom,
        center: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, center),
        children: icon && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_react_google_maps_api__WEBPACK_IMPORTED_MODULE_4__/* .Marker */ .Jx, {
            position: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, center),
            icon: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, icon)
        })
    });
};



/***/ }),

/***/ 70842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ VehicleDetail_ReviewsContainer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 5 modules
var emotion_styled_browser_esm = __webpack_require__(78555);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider = __webpack_require__(55517);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./base-components/index.ts + 14 modules
var base_components = __webpack_require__(9891);
// EXTERNAL MODULE: ./utils/helpers.js
var helpers = __webpack_require__(44108);
// EXTERNAL MODULE: ./node_modules/@fluidtruck/avatar/dist/esm/avatar.js + 1 modules
var esm_avatar = __webpack_require__(19664);
;// CONCATENATED MODULE: ./components/VehicleDetail/ReviewCard.jsx







var mq = (0,helpers/* generateMQ */.Nt)("max");
var StyledContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "es3df6r0"
})((0,_define_property/* default */.Z)({
    display: "flex",
    flexDirection: "column"
}, mq[0], {
    paddingLeft: 24
}));
var CardHeader = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "es3df6r1"
})({
    display: "flex"
});
var NameDateContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "es3df6r2"
})({
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    paddingLeft: 20
});
var ReviewContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "es3df6r3"
})({
    padding: "15px 24px 15px 0",
    display: "flex",
    flexWrap: "wrap",
    wordBreak: "break-all"
});
var StyledSpan = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "es3df6r4"
})(function(props) {
    var ref, ref1;
    return {
        color: props === null || props === void 0 ? void 0 : (ref = props.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.black
    };
});
var StyledHeader = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(base_components/* SubHeader */.bU, {
    target: "es3df6r5"
})(function(props) {
    var ref, ref1;
    return {
        color: props === null || props === void 0 ? void 0 : (ref = props.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.adaGray
    };
});
var getInitial = function(letter) {
    return "".concat(letter.slice(0, 1), ".") || 0;
};
var ReviewCard = function(param) {
    var avatar = param.avatar, reviewDate = param.reviewDate, first = param.first, last = param.last, review = param.review;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledContainer, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardHeader, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(esm_avatar/* Avatar */.q, {
                        src: avatar
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NameDateContainer, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeader, {
                                size: 14,
                                children: [
                                    first,
                                    " ",
                                    getInitial(last)
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSpan, {
                                children: reviewDate
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ReviewContainer, {
                children: [
                    review,
                    " "
                ]
            })
        ]
    });
};
/* harmony default export */ var VehicleDetail_ReviewCard = (ReviewCard);
ReviewCard.propTypes = {
    avatar: (prop_types_default()).string,
    reviewDate: (prop_types_default()).string,
    first: (prop_types_default()).string,
    last: (prop_types_default()).string,
    review: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./components/VehicleDetail/ReviewsContainer.jsx









var ReviewsContainer_mq = (0,helpers/* generateMQ */.Nt)("max");
var ReviewsContainer_StyledContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1bb6y3f0"
})((0,_define_property/* default */.Z)({
    display: "flex",
    paddingTop: 48
}, ReviewsContainer_mq[0], {
    padding: "24px 0 0 24px"
}));
var StyledDivider = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Divider/* default */.Z, {
    target: "e1bb6y3f1"
})(function(props) {
    var ref, ref1;
    return (0,_define_property/* default */.Z)({
        color: props === null || props === void 0 ? void 0 : (ref = props.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.gray[400],
        margin: "24px 0",
        height: 1
    }, ReviewsContainer_mq[0], {
        width: "100%"
    });
});
var ReviewsContainer = function(param) {
    var reviewInfo = param.reviewInfo, noHeader = param.noHeader;
    var cards = reviewInfo === null || reviewInfo === void 0 ? void 0 : reviewInfo.map(function(review) {
        var ref, ref1, ref2;
        var time = moment_default()(review === null || review === void 0 ? void 0 : review["inserted-at"]).format("LL");
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VehicleDetail_ReviewCard, {
            avatar: review === null || review === void 0 ? void 0 : (ref = review.reviewer) === null || ref === void 0 ? void 0 : ref["avatar-url"],
            reviewDate: time,
            first: review === null || review === void 0 ? void 0 : (ref1 = review.reviewer) === null || ref1 === void 0 ? void 0 : ref1.first,
            last: review === null || review === void 0 ? void 0 : (ref2 = review.reviewer) === null || ref2 === void 0 ? void 0 : ref2.last,
            review: review === null || review === void 0 ? void 0 : review["public-comment"]
        }, review === null || review === void 0 ? void 0 : review.ID);
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            !noHeader && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReviewsContainer_StyledContainer, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_components/* Header */.h4, {
                    size: 24,
                    children: "Reviews"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDivider, {
                orientation: "horizontal",
                variant: "middle"
            }),
            cards
        ]
    });
};
/* harmony default export */ var VehicleDetail_ReviewsContainer = (ReviewsContainer);
ReviewsContainer.propTypes = {
    reviewInfo: prop_types_default().oneOfType([
        (prop_types_default()).array
    ]),
    noHeader: (prop_types_default()).bool
};


/***/ }),

/***/ 91196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ ElectricVehicleMarkerBtoa; },
/* harmony export */   "e": function() { return /* binding */ electricVehicleMarker; }
/* harmony export */ });
/* provided dependency */ var Buffer = __webpack_require__(48764)["lW"];
var electricVehicleMarker = function(isAvailable) {
    return '\n<svg width="42" height="57" viewBox="0 0 42 57" fill="none" xmlns="http://www.w3.org/2000/svg">\n<g filter="url(#EVItemLocation_svg__filter0_d)">\n<mask id="EVItemLocation_svg__a" fill="#fff">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M35.142 26.33A16.803 16.803 0 0038 16.93C38 7.581 30.389 0 21 0S4 7.58 4 16.931c0 3.477 1.053 6.71 2.858 9.399h-.003l13.047 19.094a1.33 1.33 0 002.196 0L35.144 26.33h-.002z"></path>\n</mask>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M35.142 26.33A16.803 16.803 0 0038 16.93C38 7.581 30.389 0 21 0S4 7.58 4 16.931c0 3.477 1.053 6.71 2.858 9.399h-.003l13.047 19.094a1.33 1.33 0 002.196 0L35.144 26.33h-.002z" fill="'.concat(isAvailable ? "#00AB61" : "#C9CDCF", '"></path>\n<path d="M35.142 26.33l-1.66-1.115-2.091 3.115h3.751v-2zm-28.284 0v2h3.751l-2.09-3.115-1.661 1.115zm-.003 0v-2H3.066l2.138 3.128 1.651-1.128zm13.047 19.094l-1.652 1.128 1.652-1.128zm2.196 0l1.651 1.128-1.651-1.128zM35.144 26.33l1.652 1.128 2.137-3.128h-3.789v2zM36 16.93c0 3.068-.927 5.914-2.518 8.284l3.32 2.23A18.804 18.804 0 0040 16.93h-4zM21 2c8.292 0 15 6.693 15 14.931h4C40 6.468 31.486-2 21-2v4zM6 16.931C6 8.693 12.708 2 21 2v-4C10.514-2 2 6.468 2 16.931h4zm2.518 8.284A14.804 14.804 0 016 16.931H2c0 3.887 1.178 7.506 3.197 10.514l3.321-2.23zM6.855 28.33h.003v-4h-.003v4zm14.698 15.965L8.507 25.201l-3.303 2.257L18.25 46.552l3.303-2.257zm-1.106 0a.67.67 0 011.106 0l-3.303 2.257c1.323 1.935 4.177 1.935 5.5 0l-3.303-2.257zm13.046-19.094L20.447 44.296l3.302 2.257 13.047-19.094-3.303-2.256zm1.65 3.129h.001v-4h-.002v4z" fill="#fff" mask="url(#EVItemLocation_svg__a)"></path>\n<path d="M16.066 17.564l6.74-8.184c.182-.223.539-.038.463.24l-2.247 8.184a.267.267 0 01-.257.196H16.27a.267.267 0 01-.206-.436z" fill="#fff" stroke="#fff" stroke-width="0.667"></path>\n<path d="M25.87 16.443l-7.332 8.31c-.189.214-.536.022-.456-.252l2.444-8.31a.267.267 0 01.256-.191h4.888c.23 0 .352.27.2.443z" fill="#fff" stroke="#fff" stroke-width="0.667"></path>\n</g>\n<defs>\n<filter id="EVItemLocation_svg__filter0_d" x="0" y="0" width="42" height="56.003" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>\n<feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>\n<feOffset dy="6"></feOffset>\n<feGaussianBlur stdDeviation="2"></feGaussianBlur>\n<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"></feColorMatrix>\n<feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>\n<feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>\n</filter>\n</defs>\n</svg>');
};
var ElectricVehicleMarkerBtoa = Buffer.from(electricVehicleMarker(true)).toString("base64");


/***/ }),

/***/ 52071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ vehicleLocationMarker; },
/* harmony export */   "t": function() { return /* binding */ VehicleLocationMarkerBtoa; }
/* harmony export */ });
/* provided dependency */ var Buffer = __webpack_require__(48764)["lW"];
var vehicleLocationMarker = function(isAvailable) {
    return '<svg width="42" height="57" viewBox="0 0 42 57" fill="none" xmlns="http://www.w3.org/2000/svg">\n<g filter="url(#ItemLocation_svg__filter0_d)">\n<mask id="ItemLocation_svg__a" fill="#fff">\n<path fill-rule="evenodd" clip-rule="evenodd" d="M35.142 26.33A16.803 16.803 0 0038 16.93C38 7.581 30.389 0 21 0S4 7.58 4 16.931c0 3.477 1.053 6.71 2.858 9.399h-.003l13.047 19.094a1.33 1.33 0 002.196 0L35.144 26.33h-.002z"></path>\n</mask>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M35.142 26.33A16.803 16.803 0 0038 16.93C38 7.581 30.389 0 21 0S4 7.58 4 16.931c0 3.477 1.053 6.71 2.858 9.399h-.003l13.047 19.094a1.33 1.33 0 002.196 0L35.144 26.33h-.002z" fill="'.concat(isAvailable ? "#FFAC06" : "#C9CDCF", '"></path>\n<path d="M35.142 26.33l-1.66-1.115-2.091 3.115h3.751v-2zm-28.284 0v2h3.751l-2.09-3.115-1.661 1.115zm-.003 0v-2H3.066l2.138 3.128 1.651-1.128zm13.047 19.094l-1.652 1.128 1.652-1.128zm2.196 0l1.651 1.128-1.651-1.128zM35.144 26.33l1.652 1.128 2.137-3.128h-3.789v2zM36 16.93c0 3.068-.927 5.914-2.518 8.284l3.32 2.23A18.804 18.804 0 0040 16.93h-4zM21 2c8.292 0 15 6.693 15 14.931h4C40 6.468 31.486-2 21-2v4zM6 16.931C6 8.693 12.708 2 21 2v-4C10.514-2 2 6.468 2 16.931h4zm2.518 8.284A14.804 14.804 0 016 16.931H2c0 3.887 1.178 7.506 3.197 10.514l3.321-2.23zM6.855 28.33h.003v-4h-.003v4zm14.698 15.965L8.507 25.201l-3.303 2.257L18.25 46.552l3.303-2.257zm-1.106 0a.67.67 0 011.106 0l-3.303 2.257c1.323 1.935 4.177 1.935 5.5 0l-3.303-2.257zm13.046-19.094L20.447 44.296l3.302 2.257 13.047-19.094-3.303-2.256zm1.65 3.129h.001v-4h-.002v4z" fill="#fff" mask="url(#ItemLocation_svg__a)"></path>\n<circle cx="21" cy="17" r="7" fill="#fff"></circle>\n</g>\n<defs>\n<filter id="ItemLocation_svg__filter0_d" x="0" y="0" width="42" height="56.003" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n<feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>\n<feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>\n<feOffset dy="6"></feOffset>\n<feGaussianBlur stdDeviation="2"></feGaussianBlur>\n<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"></feColorMatrix>\n<feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>\n<feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>\n</filter>\n</defs>\n</svg>');
};
var VehicleLocationMarkerBtoa = Buffer.from(vehicleLocationMarker(true)).toString("base64");


/***/ }),

/***/ 71141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ svgToBase64; }
/* harmony export */ });
var svgToBase64 = function(param) {
    var icon = param.icon;
    return "data:image/svg+xml;charset=UTF-8;base64,".concat(btoa("".concat(icon)));
};


/***/ })

}]);